<template>
    <div class="k-page-content">
        <el-tabs v-model="activeName" class="box-eltab">
            <el-tab-pane label="执行明细" name="first">
                <div class="k-page-common">
                    <div class="k-common-header">
                        <div class="k-filter-option k-filter-input" style="margin-bottom: 0">
                            <el-form :inline="true" :model="searchForm" size="mini" ref="searchForm">
                                <el-form-item label="执行编码">
                                    <el-input v-model="searchForm.execute_code" placeholder="请填写执行编码"
                                        clearable></el-input>
                                </el-form-item>
                                <el-form-item label="资源名称">
                                    <el-input v-model="searchForm.resource_name" placeholder="请填写资源名称"
                                        clearable></el-input>
                                </el-form-item>
                                <el-form-item label="执行状态">
                                    <el-select v-model="searchForm.status" placeholder="请选择执行状态" style="width: 100%"
                                        clearable>
                                        <el-option v-for="item in options.status_options" :key="item.value"
                                            :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="项目名称">
                                    <el-input v-model="searchForm.project_name" placeholder="请填写项目名称"
                                        clearable></el-input>
                                </el-form-item>
                                <el-form-item label="项目编码">
                                    <el-input v-model="searchForm.project_code" placeholder="请填写项目编码"
                                        clearable></el-input>
                                </el-form-item>
                                <el-form-item label="供应商名称" v-show="checked_status.includes('supplier_name')">
                                    <el-input v-model="searchForm.supplier_name" placeholder="请填写供应商名称"
                                        clearable></el-input>
                                </el-form-item>
                                <el-form-item label="供应商编码" v-show="checked_status.includes('supplier_code')">
                                    <el-input v-model="searchForm.supplier_code" placeholder="请填写供应商编码"
                                        clearable></el-input>
                                </el-form-item>
                                <el-form-item label="所属平台" v-show="checked_status.includes('platform_id')">
                                    <el-select v-model="searchForm.platform_id" placeholder="请选择所属平台"
                                        style="width: 100%" clearable>
                                        <el-option v-for="item in options.plateForm_options" :key="item.value"
                                            :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="是否平台下单" v-show="checked_status.includes('is_platform_order')">
                                    <el-select v-model="searchForm.is_platform_order" placeholder="请选择是否平台下单"
                                        style="width: 100%" clearable>
                                        <el-option v-for="item in options.is_platform_order_options" :key="item.value"
                                            :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="是否返点" v-show="checked_status.includes('is_point')">
                                    <el-select v-model="searchForm.is_point" placeholder="请选择是否返点" style="width: 100%"
                                        clearable>
                                        <el-option v-for="item in options.is_point_options" :key="item.value"
                                            :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="是否统一结算" v-show="checked_status.includes('is_payment')">
                                    <el-select v-model="searchForm.is_payment" placeholder="请选择是否统一结算"
                                        style="width: 100%" clearable>
                                        <el-option v-for="item in options.is_payment_options" :key="item.value"
                                            :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="发布日期" v-show="checked_status.includes('release_time')">
                                    <el-date-picker clearable v-model="searchForm.release_time" type="daterange"
                                        format="yyyy-MM-dd" value-format="yyyy-MM-dd" range-separator="至"
                                        start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                                </el-form-item>
                                <el-form-item label="商务" v-show="checked_status.includes('business_docking_id')">
                                    <el-select v-model="searchForm.business_docking_id" filterable remote
                                        :remote-method="query => getUserSelect(query, 'shangwu')" placeholder="请选择商务"
                                        clearable>
                                        <el-option v-for="item in options.business_docking_id_options" :key="item.value"
                                            :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="媒介执行" v-show="checked_status.includes('edit_medium_id')">
                                    <el-select v-model="searchForm.edit_medium_id" filterable remote
                                        :remote-method="query => getUserSelect(query, 'meijie')" placeholder="请选择媒介执行"
                                        clearable>
                                        <el-option v-for="item in options.edit_medium_id_options" :key="item.value"
                                            :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="客户执行" v-show="checked_status.includes('uid')">
                                    <el-select v-model="searchForm.uid" filterable remote
                                        :remote-method="query => getUserSelect(query, 'kehu')" placeholder="请选择客户"
                                        clearable>
                                        <el-option v-for="item in options.uid_options" :key="item.value"
                                            :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="项目所属部门" v-show="checked_status.includes('dept_id')">
                                    <el-cascader v-model="searchForm.dept_id" :options="options.dept_id_options" :props="{
                                        checkStrictly: true,
                                        label: 'department_name',
                                        value: 'id',
                                    }" clearable></el-cascader>
                                </el-form-item>
                                <el-form-item label="创建日期">
                                    <el-date-picker clearable v-model="searchForm.create_time" type="daterange"
                                        format="yyyy-MM-dd" value-format="yyyy-MM-dd" range-separator="至"
                                        start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                                </el-form-item>
                                <el-form-item>
                                    <el-dropdown style="margin-right:10px;" trigger="click" :hide-on-click="false">
                                        <el-button plain>
                                            更多搜索项<i class="el-icon-arrow-down el-icon--right"></i>
                                        </el-button>
                                        <el-dropdown-menu slot="dropdown" placement="bottom"
                                            :style="{ maxHeight: '400px', overflowY: 'auto' }">
                                            <el-dropdown-item class="select-all-item">
                                                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
                                                    @change="handleCheckAllChange">
                                                    全选
                                                </el-checkbox>
                                            </el-dropdown-item>
                                            <el-dropdown-item divided></el-dropdown-item>
                                            <el-dropdown-item v-for="item in options.searchoptions" :key="item.value"
                                                :checked="item.checked" :disabled="item.disabled">
                                                <el-checkbox v-model="item.selected" style="margin-right: 8px"
                                                    @change="handleCheckChange(item)">{{ item.label }}</el-checkbox>
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                    <el-button type="primary" @click="doSearch">查询</el-button>
                                    <el-button type="primary" @click="reset">重置</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div class="k-common-con">
                        <div class="k-table-wrapper">
                            <div class="k-table-toolbar" style="margin-top: 0" v-if="
                                $parent.$parent.isAuthAction(
                                    'admin/customers/export/exportExecuteduizhangexcel'
                                ) ||
                                $parent.$parent.isAuthAction(
                                    'admin/customers/export/importexecuteexcel'
                                ) ||
                                $parent.$parent.isAuthAction(
                                    'admin/resources/resources/pymentrequest'
                                ) ||
                                $parent.$parent.isAuthAction(
                                    'admin/customers/customer/applyinvoice'
                                ) ||
                                $parent.$parent.isAuthAction(
                                    'admin/customers/customer/craterefundrequest'
                                ) ||
                                $parent.$parent.isAuthAction(
                                    'admin/customers/customer/confirmreconciliation'
                                ) ||
                                $parent.$parent.isAuthAction(
                                    'admin/customers/customer/cancelreconciliation'
                                ) ||
                                $parent.$parent.isAuthAction(
                                    'admin/customers/export/exportexecuteexcel'
                                ) ||
                                $parent.$parent.isAuthAction(
                                    'admin/customers/export/importreplaceexcel'
                                )
                            ">
                                <div>
                                    <!-- v-if="$parent.$parent.isAuthAction('admin/customers/customer/createproject')" -->
                                    <el-button type="primary" size="mini" plain :disabled="isDownDuiZhangloading"
                                        @click="exportDuiZhangData" v-if="
                                            $parent.$parent.isAuthAction(
                                                'admin/customers/export/exportExecuteduizhangexcel'
                                            )
                                        ">
                                        {{ isDownDuiZhangloading ? '下载中...' : '下载对账明细' }}
                                    </el-button>
                                    <el-button type="primary" size="mini" plain @click="openUpload" v-if="
                                        $parent.$parent.isAuthAction(
                                            'admin/customers/export/importexecuteexcel'
                                        )
                                    ">
                                        上传对账明细
                                    </el-button>
                                    <el-button type="primary" size="mini" @click="payOpen"
                                        :disabled="selects.length == 0" v-if="
                                            $parent.$parent.isAuthAction(
                                                'admin/resources/resources/pymentrequest'
                                            )
                                        ">
                                        付款申请
                                    </el-button>
                                    <el-button type="primary" size="mini" @click="payInvoiceOpen"
                                        :disabled="selects.length == 0" v-if="
                                            $parent.$parent.isAuthAction(
                                                'admin/customers/customer/applyinvoice'
                                            )
                                        ">
                                        收票申请
                                    </el-button>
                                    <el-button type="primary" size="mini" @click="refundOpen"
                                        :disabled="selects.length == 0" v-if="
                                            $parent.$parent.isAuthAction(
                                                'admin/customers/customer/craterefundrequest'
                                            )
                                        ">
                                        退款申请
                                    </el-button>
                                    <el-button type="primary" size="mini" @click="openBill"
                                        :disabled="selects.length == 0" v-if="
                                            $parent.$parent.isAuthAction(
                                                'admin/customers/customer/confirmreconciliation'
                                            )
                                        ">
                                        确认对账
                                    </el-button>
                                    <el-button type="primary" size="mini" @click="cancelBill"
                                        :disabled="selects.length == 0" v-if="
                                            $parent.$parent.isAuthAction(
                                                'admin/customers/customer/cancelreconciliation'
                                            )
                                        ">
                                        撤销对账
                                    </el-button>
                                    <el-button type="primary" size="mini" plain @click="openUploadReplace" v-if="
                                        $parent.$parent.isAuthAction(
                                            'admin/customers/export/importreplaceexcel'
                                        )
                                    ">
                                        批量上传发布链接
                                    </el-button>
                                </div>
                                <div style="margin-right: 10px">
                                    <el-link type="primary" icon="el-icon-download" :disabled="isDownloading"
                                        @click="exportData" v-if="
                                            $parent.$parent.isAuthAction(
                                                'admin/customers/export/exportexecuteexcel'
                                            )
                                        ">
                                        {{ isDownloading ? '下载中...' : '下载' }}
                                    </el-link>
                                </div>
                            </div>
                            <div class="k-table-con">
                                <el-table :data="tableData.data" style="width: 100%" border stripe ref="table"
                                    highlight-current-row @sort-change="sortChange" :height="tableHeight"
                                    :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
                                    <el-table-column type="selection" align="center" width="40"></el-table-column>
                                    <!-- <el-table-column
                                        fixed
                                        prop="id"
                                        label="ID"
										align="center"
                                        width="50">
                                </el-table-column> -->
                                    <el-table-column fixed prop="execute_code" label="执行信息" min-width="270">
                                        <template slot-scope="scope">
                                            <p>编码：{{ scope.row.execute_code }}</p>
                                            <p>资源：{{ scope.row.resource_id_txt }}</p>
                                        </template>
                                    </el-table-column>
                                    <!-- <el-table-column fixed prop="resource_id_txt" label="资源名称"
                                        min-width="100"></el-table-column> -->
                                    <!-- <el-table-column prop="supplier_code" label="供应商编码"
                                    min-width="150"></el-table-column> -->
                                    <!-- <el-table-column prop="short_name_txt" label="供应商简称"
                                        min-width="120"></el-table-column> -->
                                    <el-table-column label="资源所属供应商" min-width="220" show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            <p>编&nbsp;&nbsp;&nbsp;码：{{ scope.row.supplier_code }}</p>
                                            <p v-if="scope.row.is_blacklist == 1">
                                                供应商：{{ scope.row.supplier_id_txt }}
                                                <span style="color: red">(停用)</span>
                                            </p>
                                            <p v-else>供应商：{{ scope.row.supplier_id_txt }}</p>
                                            <p>简&nbsp;&nbsp;&nbsp;称：{{ scope.row.short_name_txt }}</p>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="project_id_txt" label="项目信息" min-width="220"
                                        show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            <p>编码：{{ scope.row.project_code }}</p>
                                            <p>名称：{{ scope.row.project_id_txt }}</p>
                                        </template>
                                    </el-table-column>
                                    <!-- <el-table-column prop="project_code" label="项目编码" min-width="160"></el-table-column> -->
                                    <el-table-column prop="customer_id_txt" label="客户信息" min-width="220"
                                        show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            <p>编码：{{ scope.row.customer_code }}</p>
                                            <p>名称：{{ scope.row.customer_id_txt }}</p>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="platform_id_txt" label="所属平台"
                                        min-width="80"></el-table-column>
                                    <el-table-column prop="is_payment_txt" label="统一结算" width="80"></el-table-column>
                                    <el-table-column prop="is_platform_order_txt" label="平台下单"
                                        width="80"></el-table-column>
                                    <el-table-column prop="is_point" label="是否返点" width="80">
                                        <template slot-scope="scope">
                                            <p v-if="scope.row.is_point == 'YES'">是</p>
                                            <p v-if="scope.row.is_point == 'NO'">否</p>
                                        </template>
                                    </el-table-column>
                                    <!-- <el-table-column
								        prop="is_payment_txt"
								        label="结算方"
								        width="90">
								</el-table-column> -->

                                    <el-table-column prop="release_method_txt" label="发布方式"
                                        min-width="100"></el-table-column>
                                    <el-table-column prop="release_time" label="发布日期" width="120"></el-table-column>
                                    <el-table-column label="价格详情" min-width="220" show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            <p style="font-weight:bold;">执行价格：{{ scope.row.strike_price }}</p>
                                            <p style="font-weight:bold;">支出金额：{{ scope.row.zhichu_price }}</p>
                                            <p style="font-weight:bold;">成本价格：{{ scope.row.baojia_chengbeng_price }}</p>
                                            <p style="font-weight:bold;">报价价格：{{ scope.row.quotation_price }}</p>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="其他详情" min-width="220" show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            <p style="font-weight:bold;">返点金额：{{ scope.row.point_price }}</p>
                                            <p style="font-weight:bold;">退款金额：{{ scope.row.xm_tk_price }}</p>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="退款剩余抵扣" width="150">
                                        <template slot-scope="scope">
                                            <template v-if="scope.row.sy_tk_dk != '--'">
                                                <el-popover placement="top" width="200" title="详情" trigger="hover">
                                                    <div class="yhLine">
                                                        <p style="font-weight: bold;color: #67C23A;"><i
                                                                style="font-size:10px;" class="el-icon-star-on"></i>
                                                            待提交&nbsp;·····&nbsp;{{ scope.row.tk_1_cost }} 元</p>
                                                        <p style="font-weight: bold;color: #E6A23C;"><i
                                                                style="font-size:10px;" class="el-icon-star-on"></i>
                                                            待审核&nbsp;·····&nbsp;{{ scope.row.tk_2_cost }} 元</p>
                                                        <p style="font-weight: bold;color: #F56C6C;"><i
                                                                style="font-size:10px;" class="el-icon-star-on"></i>
                                                            已使用&nbsp;·····&nbsp;{{ scope.row.tk_4_cost }} 元</p>
                                                    </div>
                                                    <p style="font-weight: bold;color: #409EFF;" slot="reference">{{
                                                        scope.row.sy_tk_dk }}</p>
                                                </el-popover>
                                            </template>
                                            <template v-else>
                                                <p style="font-weight: bold;color: #409EFF;">{{ scope.row.sy_tk_dk }}
                                                </p>
                                            </template>

                                        </template>
                                    </el-table-column>

                                    <el-table-column prop="invoicestatus" label="收票状态" width="100" :filters="[
                                        { text: '--', value: 'no_invoice' },
                                        { text: '未收票', value: 'no' },
                                        { text: '部分收票', value: 'other' },
                                        { text: '全部收票', value: 'all' },
                                        { text: '错误状态', value: 'none' },
                                    ]" :filter-method="filterinvoicestatus">
                                        <template slot-scope="scope">
                                            <p v-if="scope.row.invoicestatus == 'no_invoice'">
                                                --
                                            </p>
                                            <p v-if="scope.row.invoicestatus == 'no'" style="color: #409eff">
                                                未收票
                                            </p>
                                            <p v-if="scope.row.invoicestatus == 'other'" style="color: #409eff">
                                                部分收票
                                            </p>
                                            <p v-if="scope.row.invoicestatus == 'all'" style="color: #67c23a">
                                                全部收票
                                            </p>
                                            <p v-if="scope.row.invoicestatus == 'none'" style="color: #f56c6c">
                                                错误状态
                                            </p>
                                        </template>
                                    </el-table-column>
                                    
                                    <el-table-column prop="paystatus" label="付款状态" width="100" :filters="[
                                        { text: '未付款', value: 'no' },
                                        { text: '部分付款', value: 'other' },
                                        { text: '全部付款', value: 'all' },
                                        { text: '错误状态', value: 'none' },
                                    ]" :filter-method="filterPaystatus">
                                        <template slot-scope="scope">
                                            <p v-if="scope.row.paystatus == 'no'" style="color: #409eff">
                                                未付款
                                            </p>
                                            <p v-if="scope.row.paystatus == 'other'" style="color: #409eff">
                                                部分付款
                                            </p>
                                            <p v-if="scope.row.paystatus == 'all'" style="color: #67c23a">
                                                全部付款
                                            </p>
                                            <p v-if="scope.row.paystatus == 'none'" style="color: #f56c6c">
                                                错误状态
                                            </p>
                                        </template>
                                    </el-table-column>

                                    <el-table-column prop="pointkpstatus" label="返点开票状态" width="120" :filters="[
                                        { text: '--', value: 'no_kp_invoice' },
                                        { text: '未开票', value: 'no' },
                                        { text: '部分开票', value: 'other' },
                                        { text: '全部开票', value: 'all' },
                                        { text: '错误状态', value: 'none' },
                                    ]" :filter-method="filterinvoicePointstatus">
                                        <template slot-scope="scope">
                                            <p v-if="scope.row.pointkpstatus == 'no_kp_invoice'">
                                                --
                                            </p>
                                            <p v-if="scope.row.pointkpstatus == 'no'" style="color: #409eff">
                                                未开票
                                            </p>
                                            <p v-if="scope.row.pointkpstatus == 'other'" style="color: #409eff">
                                                部分开票
                                            </p>
                                            <p v-if="scope.row.pointkpstatus == 'all'" style="color: #67c23a">
                                                全部开票
                                            </p>
                                            <p v-if="scope.row.pointkpstatus == 'none'" style="color: #f56c6c">
                                                错误状态
                                            </p>
                                        </template>
                                    </el-table-column>
                                    
                                    <el-table-column prop="point_status_txt" label="返点状态" width="100" :filters="[
                                        { text: '无返点', value: 'no_point' },
                                        { text: '未确认', value: 'no_confim' },
                                        { text: '已确认', value: 'yes_confim' },
                                        { text: '部分收款', value: 'other' },
                                        { text: '全部收款', value: 'all' },
                                        { text: '错误状态', value: 'none' },
                                    ]" :filter-method="filterPointstatus"></el-table-column>
                                    <el-table-column prop="platform_status_txt" label="平台对账" align="center" width="100"
                                        :filters="[
                                            { text: '未对账', value: '0' },
                                            { text: '已对账', value: '1' },
                                            { text: '无需对账', value: '2' },
                                        ]" :filter-method="filterPstatus"></el-table-column>
                                    <el-table-column label="执行价对比" width="100">
                                        <template slot-scope="scope">
                                            <el-popover placement="right" width="330"
                                                v-if="scope.row.dd_quotation_price_arr.length > 0" trigger="hover">
                                                <div class="ressupplier">
                                                    <div class="_row">
                                                        <div class="str">原执行价</div>
                                                        <div class="dashed"></div>
                                                        <div class="price">
                                                            {{ scope.row.dd_strike_price_arr[0] }}
                                                        </div>
                                                    </div>
                                                    <div class="_row">
                                                        <div class="str">现执行价</div>
                                                        <div class="dashed"></div>
                                                        <div class="price">
                                                            {{ scope.row.dd_strike_price_arr[1] }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <p :style="{
                                                    color: isColor(scope.row.dd_strike_price),
                                                    'font-weight': 'bold',
                                                }" slot="reference">
                                                    {{ isUp(scope.row.dd_strike_price) }}
                                                </p>
                                            </el-popover>
                                            <p v-else :style="{
                                                color: isColor(scope.row.dd_strike_price),
                                                'font-weight': 'bold',
                                            }" slot="reference">
                                                {{ isUp(scope.row.dd_strike_price) }}
                                            </p>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="报价对比" width="100">
                                        <template slot-scope="scope">
                                            <el-popover placement="right" width="330"
                                                v-if="scope.row.dd_quotation_price_arr.length > 0" trigger="hover">
                                                <div class="ressupplier">
                                                    <div class="_row">
                                                        <div class="str">原报价</div>
                                                        <div class="dashed"></div>
                                                        <div class="price">
                                                            {{
                                                                scope.row.dd_quotation_price_arr[0]
                                                            }}
                                                        </div>
                                                    </div>
                                                    <div class="_row">
                                                        <div class="str">现报价</div>
                                                        <div class="dashed"></div>
                                                        <div class="price">
                                                            {{
                                                                scope.row.dd_quotation_price_arr[1]
                                                            }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <p :style="{
                                                    color: isColor(
                                                        scope.row.dd_quotation_price
                                                    ),
                                                    'font-weight': 'bold',
                                                }" slot="reference">
                                                    {{ isUp(scope.row.dd_quotation_price) }}
                                                </p>
                                            </el-popover>
                                            <p v-else :style="{
                                                color: isColor(scope.row.dd_quotation_price),
                                                'font-weight': 'bold',
                                            }">
                                                {{ isUp(scope.row.dd_quotation_price) }}
                                            </p>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="dd_lirun" label="利润对比" width="100">
                                        <template slot-scope="scope">
                                            <el-popover placement="right" width="330"
                                                v-if="scope.row.dd_lirun_arr.length > 0" trigger="hover">
                                                <div class="ressupplier">
                                                    <div class="_row">
                                                        <div class="str">原利润</div>
                                                        <div class="dashed"></div>
                                                        <div class="price">
                                                            {{ scope.row.dd_lirun_arr[0] }}
                                                        </div>
                                                    </div>
                                                    <div class="_row">
                                                        <div class="str">现利润</div>
                                                        <div class="dashed"></div>
                                                        <div class="price">
                                                            {{ scope.row.dd_lirun_arr[1] }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <p :style="{
                                                    color: isColor(scope.row.dd_lirun),
                                                    'font-weight': 'bold',
                                                }" slot="reference">
                                                    {{ isUp(scope.row.dd_lirun) }}
                                                </p>
                                            </el-popover>
                                            <p v-else :style="{
                                                color: isColor(scope.row.dd_lirun),
                                                'font-weight': 'bold',
                                            }">
                                                {{ isUp(scope.row.dd_lirun) }}
                                            </p>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="dd_lirun_lv" label="利润率对比" width="100">
                                        <template slot-scope="scope">
                                            <el-popover placement="right" width="330"
                                                v-if="scope.row.dd_lirun_lv_arr.length > 0" trigger="hover">
                                                <div class="ressupplier">
                                                    <div class="_row">
                                                        <div class="str">原利润率</div>
                                                        <div class="dashed"></div>
                                                        <div class="price">
                                                            {{ scope.row.dd_lirun_lv_arr[0] }}
                                                        </div>
                                                    </div>
                                                    <div class="_row">
                                                        <div class="str">现利润率</div>
                                                        <div class="dashed"></div>
                                                        <div class="price">
                                                            {{ scope.row.dd_lirun_lv_arr[1] }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <p :style="{
                                                    color: isColor(scope.row.dd_lirun_lv),
                                                    'font-weight': 'bold',
                                                }" slot="reference">
                                                    {{ isUp(scope.row.dd_lirun_lv) }}
                                                </p>
                                            </el-popover>
                                            <p v-else :style="{
                                                color: isColor(scope.row.dd_lirun_lv),
                                                'font-weight': 'bold',
                                            }">
                                                {{ isUp(scope.row.dd_lirun_lv) }}
                                            </p>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="recommend_message" label="推荐理由"
                                        min-width="200"></el-table-column>
                                    <el-table-column prop="remark" label="备注" :show-overflow-tooltip="true"
                                        min-width="200"></el-table-column>
                                    <el-table-column prop="point_uid_txt" label="返点责任人" width="100"></el-table-column>
                                    <el-table-column prop="point_uid_depar_txt" label="返点责任部门"
                                        width="100"></el-table-column>
                                    <el-table-column prop="business_docking_id_txt" label="所属商务"
                                        width="100"></el-table-column>
                                    <el-table-column prop="medium_id_txt" label="媒介执行" width="100"></el-table-column>
                                    <el-table-column prop="uid_txt" label="客户执行" width="100"></el-table-column>
                                    <el-table-column prop="uid_depar_txt" label="项目所属部门" width="100"></el-table-column>
                                    <el-table-column prop="create_time" label="创建时间" width="150"
                                        sortable="custom"></el-table-column>
                                    <el-table-column fixed="right" prop="status_txt" label="执行状态" align="center"
                                        width="90" :filters="[
                                            { text: '待提交', value: '1' },
                                            { text: '待审核', value: '2' },
                                            { text: '被驳回', value: '3' },
                                            { text: '正常', value: '4' },
                                            { text: '匹配中', value: '5' },
                                            { text: '已发布', value: '6' },
                                            { text: '供应商对账', value: '7' },
                                            { text: '已作废', value: '8' },
                                            { text: '撤销中', value: '9' },
                                            { text: '待报价', value: '10' },
                                        ]" :filter-method="filterStatus"></el-table-column>
                                    <el-table-column fixed="right" label="操作" v-if="
                                        $parent.$parent.isAuthAction(
                                            'admin/customers/customer/remarkaction'
                                        ) ||
                                        $parent.$parent.isAuthAction(
                                            'admin/customers/customer/cancelproresource'
                                        ) ||
                                        $parent.$parent.isAuthAction(
                                            'admin/customers/customer/getreplaceurl'
                                        )
                                    " width="150">
                                        <template slot-scope="scope">
                                            <el-button type="text" size="small" :disabled="[2, 3, 8, 9, 10, 11].indexOf(
                                                scope.row.project_status
                                            ) != -1
                                                " @click="remarkaction(scope.row)" v-if="
                                                    $parent.$parent.isAuthAction(
                                                        'admin/customers/customer/remarkaction'
                                                    )
                                                ">
                                                备注
                                            </el-button>
                                            <el-button @click="handleTableDelete(scope.row)" type="text" size="small"
                                                class="c-danger" :disabled="!(
                                                    [1, 2, 3, 4, 5, 6, 10].indexOf(
                                                        scope.row.status
                                                    ) != -1 &&
                                                    scope.row.paystatus == 'no' &&
                                                    scope.row.project_sk_status == 'no' &&
                                                    scope.row.project_kp_status == 'no' &&
                                                    (scope.row.pointkpstatus == 'no' || scope.row.pointkpstatus =='no_kp_invoice') &&
                                                    [
                                                        'no_point',
                                                        'yes_confim',
                                                        'no_confim',
                                                        'none',
                                                    ].indexOf(scope.row.point_status) != -1 &&
                                                    (scope.row.invoicestatus == 'no_invoice' || scope.row.invoicestatus == 'no')
                                                )
                                                    " v-if="
                                                        $parent.$parent.isAuthAction(
                                                            'admin/customers/customer/cancelproresource'
                                                        )
                                                    ">
                                                作废
                                            </el-button>
                                            <el-button type="text" size="small" @click="openLink(scope.row)" :disabled="!(
                                                [1, 2, 3, 5, 7, 8, 9, 10].indexOf(
                                                    scope.row.status
                                                ) == -1
                                            )
                                                " v-if="
                                                    $parent.$parent.isAuthAction(
                                                        'admin/customers/customer/getreplaceurl'
                                                    )
                                                ">
                                                发布链接
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <el-pagination background ref="pagination" @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange" :current-page="tableData.page | number"
                                    :page-sizes="[15, 30, 50, 100, 200]" :page-size="tableData.pagesize | number"
                                    layout="prev, pager, next, sizes, total"
                                    :total="tableData.total | number"></el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
        <el-dialog title="申请付款" custom-class="k-drawer" :visible.sync="payFormVisible" :close-on-click-modal="false"
            :close-on-press-escape="false" direction="rtl" @closed="clearAddForm('addForm')" width="90%">
            <el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="110px"
                v-loading="loading">
                <div class="drawer-content">
                    <el-form-item :label="addForm.supplier_id == '0' ? '平台' : '供应商'" prop="supplier_id">
                        <el-input v-model="addForm.supplier_name" disabled></el-input>
                    </el-form-item>
                    <el-form-item>
                        <div style="padding-top: 8px; color: #f56c6c; font-size: 13px" v-if="execute_tips">
                            {{ execute_tips }}
                        </div>
                    </el-form-item>
                    <el-row v-for="(item, index) in addForm.resource_project_list" :key="index">
                        <el-form-item style="margin-bottom: 0">
                            <el-col :span="10">
                                <el-form-item label="执行编码:" label-width="78px">
                                    <el-input v-model="addForm.resource_project_list[index].execute_code" clearable
                                        disabled></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="资源名称:" label-width="78px">
                                    <el-input v-model="addForm.resource_project_list[index].name" clearable
                                        disabled></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="金额:" :prop="`resource_project_list[${index}].cost`" :rules="[
                                    {
                                        required: true,
                                        validator: validatorLrId,
                                        trigger: 'blur',
                                    },
                                ]" label-width="65px">
                                    <el-input v-model="addForm.resource_project_list[index].cost"
                                        placeholder="请填写使用金额"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                    </el-row>
                    <el-form-item label="收款方">
                        <el-radio-group v-model="addForm.receive_type" @input="getNewSupplier">
                            <el-radio label="OLD">原收款方</el-radio>
                            <el-radio label="NEW">其他收款方</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="其他供应商" v-if="addForm.receive_type == 'NEW'">
                        <el-select style="width: 100%" v-model="addForm.new_supplier_id" filterable remote
                            placeholder="请选择其他供应商" clearable @change="getBankCardNew"
                            :remote-method="getSupplierSelect">
                            <el-option v-for="item in options.new_supplier_id_options" :key="item.value"
                                :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="收款银行" prop="payee_bank_id">
                        <el-select v-model="addForm.payee_bank_id" placeholder="请选择收款银行" clearable style="width: 100%">
                            <el-option v-for="item in options.bankCard_options" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否抵扣" prop="is_deduction" v-if="addForm.payee_bank_id">
                        <el-radio-group v-model="addForm.is_deduction" @input="changeRefund">
                            <el-radio :label="0">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="退款抵扣" prop="deduction_amount"
                        v-if="addForm.is_deduction == 1">
                        <el-select multiple filterable clearable v-model="addForm.refund_ids" placeholder="请选择退款抵扣"
                            @change="updateStatus">
                            <el-option v-for="item in options.refund_options" :key="item.value"
                                :disabled="item.disabled" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="付款日期" prop="advance_payment_date">
                        <el-date-picker key="advance_payment_date" v-model="addForm.advance_payment_date" type="date"
                            format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="申请备注">
                        <el-input type="textarea" v-model="addForm.remark" placeholder="请填写申请备注" clearable
                            maxlength="100" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="附件">
                        <el-upload action accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xlsx,.xlx,.ppt,.pptx,.eml,.bmp"
                            :file-list="addForm.attachment" :on-remove="file => handleRemoveUpload(file, 'addForm', 'attachment', false)
                                " :auto-upload="false" :on-change="file => changeRequired(file, 'addForm', 'attachment', false)
                                    " :on-preview="viewImg" :multiple="true">
                            <el-button slot="trigger" size="mini">选取文件</el-button>
                            <span style="margin-left: 10px; cursor: pointer">
                                <el-tooltip class="item" effect="dark"
                                    content="支持jpg/png/jpeg/pdf/doc/docx/xlsx/xlx/ppt/pptx/eml/bmp格式"
                                    placement="bottom-start">
                                    <i class="el-icon-warning-outline"
                                        style="padding: 0 6px; color: #cccccc !important"></i>
                                </el-tooltip>
                            </span>
                        </el-upload>
                    </el-form-item>
                </div>
                <div class="drawer-footer" style="text-align: right">
                    <el-button :size="size" @click="handlePaymentButtonClick">取消</el-button>
                    <el-button type="primary" @click="addInvoice" :size="size">提交</el-button>
                </div>
            </el-form>
        </el-dialog>
        <!-- 申请收票 -->
        <el-dialog title="申请收票" custom-class="k-drawer" :visible.sync="payInvoiceFormVisible"
            :close-on-click-modal="false" :close-on-press-escape="false" direction="rtl"
            @closed="clearAddForm('addPayForm')" width="90%">
            <el-form :model="addPayForm" ref="addPayForm" :size="size" :rules="rules.addPayForm" label-width="120px"
                v-loading="loading">
                <div class="drawer-content">
                    <el-form-item>
                        <div style="padding-top: 8px; color: #f56c6c; font-size: 13px" v-if="invoice_tips">
                            {{ invoice_tips }}
                        </div>
                    </el-form-item>
                    <el-row v-for="(item, index) in addPayForm.invoice_array" :key="index">
                        <el-form-item style="margin-bottom: 0">
                            <el-col :span="7">
                                <el-form-item label="执行编码:" label-width="78px">
                                    <el-input v-model="addPayForm.invoice_array[index].execute_code" clearable
                                        disabled></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="11">
                                <el-form-item label="发票录入:" :prop="`invoice_array[${index}].invioce_lr_id`" :rules="[
                                    {
                                        required: true,
                                        validator: (rule, value, callback) => {
                                            if (!value) {
                                                callback('请选择发票录入')
                                            } else {
                                                callback()
                                            }
                                        },
                                        trigger: 'blur',
                                    },
                                ]">
                                    <el-select v-model="addPayForm.invoice_array[index].invioce_lr_id" filterable remote
                                        clearable placeholder="请选择发票录入" style="width: 100%" @change="getCost(index)"
                                        :remote-method="getInviocelrId">
                                        <el-option v-for="item in options.invioce_lr_id_options" :key="item.value"
                                            :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="使用金额:" :prop="`invoice_array[${index}].cost`" :rules="[
                                    {
                                        required: true,
                                        validator: validatorLrIdInvo,
                                        trigger: 'blur',
                                    },
                                ]">
                                    <el-input v-model="addPayForm.invoice_array[index].cost"
                                        placeholder="请填写使用金额"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                    </el-row>
                    <el-form-item label="开票方">
                        <el-radio-group v-model="addPayForm.receive_type" @input="getNewInvoiceSupplier">
                            <el-radio label="OLD">原开票方</el-radio>
                            <el-radio label="NEW">其他开票方</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="其他供应商" prop="new_supplier_id" v-if="addPayForm.receive_type == 'NEW'">
                        <el-select style="width: 100%" v-model="addPayForm.new_supplier_id" filterable remote
                            placeholder="请选择供应商" clearable @change="getInvoiceInfo" :remote-method="getSupplierSelect">
                            <el-option v-for="item in options.new_supplier_id_options" :key="item.value"
                                :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="开票信息" prop="invoice_id">
                        <el-select v-model="addPayForm.invoice_id" filterable placeholder="请选择开票信息" clearable
                            style="width: 100%">
                            <el-option v-for="item in options.invoice_id_options" :key="item.value" :label="item.is_defult
                                ? item.is_defult + '--' + item.info + '/' + item.label
                                : item.info + '/' + item.label
                                " :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="申请备注">
                        <el-input type="textarea" v-model="addPayForm.remark" placeholder="请填写申请备注" clearable
                            maxlength="100" show-word-limit></el-input>
                    </el-form-item>
                </div>
                <div class="drawer-footer" style="text-align: right">
                    <el-button :size="size" @click="payInvoiceFormVisible = false">取消</el-button>
                    <el-button type="primary" @click="addInvoicePay" :size="size">提交</el-button>
                </div>
            </el-form>
        </el-dialog>
        <el-dialog title="发布链接" v-loading="loading" :visible.sync="linkVisible" :close-on-click-modal="false"
            :close-on-press-escape="false" width="50%">
            <el-form :model="linkForm" ref="linkForm" :size="size" :rules="rules.linkForm" label-width="110px">
                <div>
                    <el-form-item label="订单编号" prop="order_num" v-if="linkForm.order_num_show">
                        <el-input v-model="linkForm.order_num" maxlength="20" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="发布链接" prop="replace_url">
                        <el-input v-model="linkForm.replace_url"></el-input>
                    </el-form-item>
                    <el-form-item label="发布日期" prop="release_time">
                        <el-date-picker v-model="linkForm.release_time" type="date" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" clearable placeholder="选择日期"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="评论数" prop="average_interaction_num">
                        <el-input v-model="linkForm.average_interaction_num"></el-input>
                    </el-form-item>
                    <el-form-item label="点赞数" prop="like_num">
                        <el-input v-model="linkForm.like_num"></el-input>
                    </el-form-item>
                    <el-form-item label="阅读数" prop="average_read_num">
                        <el-input v-model="linkForm.average_read_num"></el-input>
                    </el-form-item>
                    <el-form-item label="转发数" prop="retweets_num">
                        <el-input v-model="linkForm.retweets_num"></el-input>
                    </el-form-item>
                    <el-form-item label="收藏数" prop="collections_num">
                        <el-input v-model="linkForm.collections_num"></el-input>
                    </el-form-item>
                    <el-form-item label="上传图片">
                        <el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="linkForm.img"
                            :on-remove="file => handleRemoveUpload(file, 'linkForm', 'img', true)" :auto-upload="false"
                            :on-change="file => changeRequired(file, 'linkForm', 'img', true)" :on-preview="viewImg">
                            <el-button slot="trigger" size="mini">选取文件</el-button>
                            <span style="margin-left: 10px; cursor: pointer">
                                <el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式"
                                    placement="bottom-start">
                                    <i class="el-icon-warning-outline"
                                        style="padding: 0 6px; color: #cccccc !important"></i>
                                </el-tooltip>
                            </span>
                        </el-upload>
                    </el-form-item>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="linkVisible = false" :size="size">取 消</el-button>
                <el-button type="primary" @click="addLink()" :size="size">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 确认对账 -->
        <el-dialog title="确认对账" :visible.sync="billVisible" :close-on-click-modal="false" :close-on-press-escape="false"
            custom-class="bill" width="80%">
            <div class="kBill">
                <div class="title">
                    <p>
                        本次对账确认
                        <span>{{ billNum }}</span>
                        条，请确认!
                    </p>
                </div>
                <div class="box">
                    <ul v-for="(item, index) in billData" :key="index">
                        <li class="t1">执行编码:{{ item.execute_code }}</li>
                        <li class="t2">供应商简称:{{ item.short_name_txt }}</li>
                        <li class="t3">退款后支出金额:{{ item.sj_zc_price }}元</li>
                        <li class="t1">供应商类型:{{ item.supplier_type }}</li>
                        <li class="t2">单次媒体返点:{{ item.point_price }}元</li>
                        <li class="t4">
                            执行明细-收款银行卡:{{ item.pay_type_txt }}-{{ item.real_name }}-{{
                                item.bank_card_num
                            }}-{{ item.bankcard_branch_txt }}{{ item.bankcard_of_deposit_txt }}
                        </li>
                    </ul>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="billVisible = false" :size="size">取 消</el-button>
                <el-button type="primary" @click="confirmbill()" :size="size">确 认</el-button>
            </span>
        </el-dialog>
        <!--上传订单-->
        <el-dialog title="上传对账明细" :visible.sync="uploadVisiable" :close-on-click-modal="false"
            :close-on-press-escape="false" v-loading="loading" width="40%">
            <el-form :model="uploadForm" ref="uploadForm" :size="size" :rules="rules.uploadForm" label-width="130px">
                <div>
                    <el-form-item label="上传文件:" prop="excel_file">
                        <el-upload drag ref="upload_excel_file" accept=".xls,.xlsx" action :http-request="file => {
                            return imggreySuccess(file, 'excel_file_files')
                        }
                            " :file-list="uploadForm.excel_file_list"
                            :on-remove="file => handleRemoveUpload2(file, 'excel_file_list')" :auto-upload="false"
                            :on-exceed="limitMessage" :limit="1">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text" style="font-size: 12px">
                                将文件拖到此处，或
                                <em>点击上传</em>
                                <br />
                                <span>支持 .xls .xlsx</span>
                            </div>
                        </el-upload>
                    </el-form-item>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addUpload()" :size="size">提交</el-button>
                <el-button :size="size" @click="uploadVisiable = false">取消</el-button>
            </span>
        </el-dialog>
        <!--上传发布链接-->
        <el-dialog title="上传发布链接" :visible.sync="uploadReplaceVisiable" :close-on-click-modal="false"
            :close-on-press-escape="false" v-loading="loading" width="40%">
            <el-form :model="uploadReplaceForm" ref="uploadReplaceForm" :size="size" :rules="rules.uploadReplaceForm"
                label-width="130px">
                <div>
                    <el-form-item label="上传文件:" prop="excel_file">
                        <el-upload drag ref="upload_replace_excel_file" accept=".xls,.xlsx" action :http-request="file => {
                            return imggreySuccessReplace(file, 'excel_file_files')
                        }
                            " :file-list="uploadReplaceForm.excel_file_list"
                            :on-remove="file => handleRemoveUploadReplace(file, 'excel_file_list')" :auto-upload="false"
                            :on-exceed="limitMessageReplace" :limit="1">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text" style="font-size: 12px">
                                将文件拖到此处，或
                                <em>点击上传</em>
                                <br />
                                <span>支持 .xls .xlsx</span>
                            </div>
                            <div class="el-upload__tip" slot="tip">
                                <a @click="downloadTemplate('replace')" target="_blank"
                                    style="color: #409eff; font-size: 12px; cursor: pointer">
                                    <i class="el-icon-download"></i>
                                    文件模板下载
                                </a>
                            </div>
                        </el-upload>
                    </el-form-item>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addUploadReplace()" :size="size">提交</el-button>
                <el-button :size="size" @click="uploadReplaceVisiable = false">取消</el-button>
            </span>
        </el-dialog>
        <!-- 错误提示 -->
        <el-dialog title="错误提示" :visible.sync="tipsVisible" :close-on-click-modal="false" :close-on-press-escape="false"
            width="70%">
            <div class="k-page-common" style="max-height: calc(100vh - 400px); overflow: auto; height: auto !important">
                <div class="k-common-con" style="margin: 0; flex: none; display: block">
                    <div class="kBill" style="height: auto">
                        <div class="title" style="color: #f56c6c">
                            <div>{{ tipsMsg }}</div>
                            <div v-if="tableData2.data.length > 0">
                                <el-link @click="exportErrorData(tableData2.path, 1)" type="primary" :underline="false"
                                    icon="el-icon-download">
                                    下载
                                </el-link>
                            </div>
                        </div>
                        <div style="padding-top: 10px; border-top: 1px solid #ebeef5" v-if="tableData2.data.length > 0">
                            <el-table :data="tableData2.data" style="width: 100%" row-key="id" border stripe
                                ref="table2" highlight-current-row>
                                <el-table-column prop="execute_id" label="执行明细编码" min-width="180"></el-table-column>
                                <el-table-column prop="resource_name" label="资源名称" min-width="150"></el-table-column>
                                <el-table-column prop="is_platform_order_txt" label="是否平台下单"
                                    min-width="100"></el-table-column>
                                <el-table-column prop="msg" label="详情" align="center" width="100">
                                    <template slot-scope="scope">
                                        <el-popover placement="left" width="430" v-if="scope.row.msg.length > 0"
                                            trigger="hover">
                                            <div class="ressupplier">
                                                <div class="_row" v-for="(item, index) in scope.row.msg" :key="index">
                                                    <div class="str" style="font-weight: normal">
                                                        {{ item }}
                                                    </div>
                                                </div>
                                            </div>
                                            <el-button type="text" size="small" class="c-danger" slot="reference">
                                                查看
                                            </el-button>
                                        </el-popover>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="tipsVisible = false" :size="size">
                    确 定
                </el-button>
            </span>
        </el-dialog>
        <el-dialog title="错误提示" :visible.sync="tipsVisible2" :close-on-click-modal="false"
            :close-on-press-escape="false" width="70%">
            <div class="k-page-common" style="max-height: calc(100vh - 400px); overflow: auto; height: auto !important">
                <div class="k-common-con" style="margin: 0; flex: none; display: block">
                    <div class="kBill" style="height: auto">
                        <div class="title" style="color: #f56c6c">
                            <div></div>
                            <!-- <div v-if="tableData3.data.length > 0">
					  		<el-link @click="exportErrorData(tableData3.path,2)" type="primary" :underline="false" icon="el-icon-download">下载</el-link>
					  	</div> -->
                        </div>
                        <div style="padding-top: 10px" v-if="tableData3.data.length > 0">
                            <el-table :data="tableData3.data" style="width: 100%" row-key="id" border stripe
                                ref="table2" highlight-current-row>
                                <el-table-column prop="code" label="执行明细编码" min-width="200"></el-table-column>
                                <el-table-column prop="msg" label="详情" min-width="300">
                                    <template slot-scope="scope">
                                        <span style="color: #f56c6c">{{ scope.row.msg }}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="tipsVisible2 = false" :size="size">
                    确 定
                </el-button>
            </span>
        </el-dialog>
        <!-- 退款申请 -->
        <el-drawer custom-class="k-drawer" :visible.sync="turnFormVisiable" direction="rtl" :wrapperClosable="false"
            :close-on-press-escape="false" @closed="clearAddForm('turnForm')" size="70%">
            <el-form :model="turnForm" ref="turnForm" :size="size" :rules="rules.turnForm" label-width="110px"
                v-loading="loading">
                <div class="drawer-header">
                    <div class="header-title">
                        <span>退款申请</span>
                        <i class="el-icon-close k-drawer-close" @click="turnFormVisiable = false"></i>
                    </div>
                </div>
                <div class="drawer-content">
                    <div class="top">
                        <el-row>
                            <el-col :span="12">执行编码:{{ turnData.execute_code }}</el-col>
                            <el-col :span="12">项目名称:{{ turnData.project_name }}</el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">是否走平台:{{ turnData.is_plarfotm_order }}</el-col>
                            <el-col :span="12">所属平台:{{ turnData.platform_name }}</el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">资源名称:{{ turnData.resource_name }}</el-col>
                            <el-col :span="12">平台单号: {{ turnData.plarfotm_order }}</el-col>
                        </el-row>
                    </div>
                    <el-form-item label="平台单号" v-if="turnForm.type == 2">
                        <el-input v-model="turnForm.plarfotm_order" placeholder="请填写平台单号" clearable maxlength="20"
                            show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="是否取消执行" prop="is_cancel_execute">
                        <el-radio-group v-model="turnForm.is_cancel_execute">
                            <el-radio :label="1" style="display: block; margin: 10px 0">
                                是，不再执行。(操作后执行明细状态为已取消/已作废)
                            </el-radio>
                            <el-radio :label="2" style="display: block; margin: 10px 0">
                                否，继续执行。(操作后执行明细状态不变，仅是退款)
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="退款账户" prop="refund_bank_id" v-if="turnForm.type == 1 || turnForm.type == 3">
                        <el-select v-model="turnForm.refund_bank_id" placeholder="请选择退款账户" clearable
                            style="width: 100%">
                            <el-option v-for="item in options.refund_bank_id_options" :key="item.value"
                                :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="收款账户" prop="collect_bank_id" v-if="turnForm.type == 1 || turnForm.type == 3">
                        <el-select v-model="turnForm.collect_bank_id" placeholder="请选择收款账户" clearable
                            style="width: 100%">
                            <el-option v-for="item in options.collect_bank_id_options" :key="item.value"
                                :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="退款金额" prop="refund_price" v-if="turnForm.execute_id">
                        <div style="display: flex">
                            <div style="width: 220px; margin-right: 10px">
                                <el-input v-model="turnForm.refund_price" placeholder="请填写退款金额" clearable
                                    @blur="changePrice"></el-input>
                            </div>
                            <span style="color: #f56c6c">
                                (可退款金额：{{ turnData.use_refund_price }})
                            </span>
                        </div>
                    </el-form-item>
                    <el-form-item label="退款日期" prop="refund_date">
                        <el-date-picker v-model="turnForm.refund_date" type="date" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="退款凭证" prop="prove_attachment">
                        <el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="turnForm.prove_attachment"
                            :on-remove="file =>
                                handleRemoveUpload(file, 'turnForm', 'prove_attachment', true)
                                " :auto-upload="false" :on-change="file => changeRequired(file, 'turnForm', 'prove_attachment', true)
                                    " :on-preview="viewImg">
                            <el-button slot="trigger" size="mini">选取文件</el-button>
                            <span style="margin-left: 10px; cursor: pointer">
                                <el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式"
                                    placement="bottom-start">
                                    <i class="el-icon-warning-outline"
                                        style="padding: 0 6px; color: #cccccc !important"></i>
                                </el-tooltip>
                            </span>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="退款原因" prop="refund_reason">
                        <el-input type="textarea" v-model="turnForm.refund_reason" placeholder="请填写退款原因" clearable
                            maxlength="100" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="退款账户" v-if="turnForm.type == 1">
						<el-radio-group v-model="turnForm.refund_method" @input="getBankNumSelect">
							<el-radio :label="2">系统账户</el-radio>
							<el-radio :label="1">银行账户</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="银行流水" prop="bank_num_id" v-if="turnForm.refund_method == 1">
						<el-select v-model="turnForm.bank_num_id" filterable placeholder="请选择银行流水" clearable style="width: 100%;"
							remote :remote-method="getBankNum">
							<el-option v-for="item in options.bank_num_id_options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
                    <el-form-item label="申请备注">
                        <el-input type="textarea" v-model="turnForm.remark" placeholder="请填写申请备注" clearable
                            maxlength="100" show-word-limit></el-input>
                    </el-form-item>
                </div>
                <div class="drawer-footer">
                    <el-button type="primary" @click="addTurn" :size="size">提交</el-button>
                    <el-button :size="size" @click="turnFormVisiable = false">取消</el-button>
                </div>
            </el-form>
        </el-drawer>
        <el-dialog :visible.sync="dialogVisibleImg">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: ['info'],
    data () {
        return {
            loading: false,
            checked_status: [],
            // checked_status: [
            //     'platform_id',
            //     'project_name',
            //     'project_code',
            //     'supplier_name',
            //     'supplier_code',
            //     'is_platform_order',
            //     'is_point',
            //     'is_payment',
            //     'release_time',
            //     'edit_medium_id',
            //     'business_docking_id',
            //     'uid',
            //     'dept_id',
            // ],
            execute_tips: '',
            invoice_tips: '',
            activeName: 'first',
            dropdownVisible: false,
            payFormVisible: false,
            payInvoiceFormVisible: false,
            linkVisible: false,
            dialogVisibleImg: false,
            billVisible: false,
            uploadVisiable: false,
            uploadReplaceVisiable: false,
            tipsVisible: false,
            tipsVisible2: false,
            turnFormVisiable: false,
            dialogImageUrl: '',
            addForm: {
                plateform_id: '',
                pay_status: '',
                supplier_id: '',
                is_deduction: 0,
                supplier_name: '',
                receive_type: 'OLD',
                new_supplier_id: '',
                execute_ids: [],
                refund_ids: [],
                resource_project_list: [],
                payee_bank_id: '',
                advance_payment_date: '',
                remark: '',
                attachment: [],
            },
            addPayForm: {
                receive_type: 'OLD',
                supplier_id: '',
                new_supplier_id: '',
                invoice_id: '',
                execute_ids: [],
                invoice_array: [],
                remark: '',
            },
            linkForm: {
                execute_id: '',
                order_num: '',
                order_num_show: false,
                replace_url: '',
                release_time: '',
                average_interaction_num: '',
                like_num: '',
                average_read_num: '',
                retweets_num: '',
                collections_num: '',
                img: [],
            },
            uploadForm: {
                excel_file: '',
                excel_file_list: [],
                excel_file_files: [],
            },
            uploadReplaceForm: {
                excel_file: '',
                excel_file_list: [],
                excel_file_files: [],
            },
            turnForm: {
                execute_id: '',
                refund_method:2,
                bank_num_id:'',
                type: '',
                is_cancel_execute: 2,
                plarfotm_order: '',
                refund_bank_id: '',
                collect_bank_id: '',
                prove_attachment: [],
                refund_date: '',
                refund_price: '',
                refund_reason: '',
                remark: '',
            },
            turnData: {
                execute_code: '',
                project_name: '',
                resource_name: '',
                platform_name: '',
                is_plarfotm_order: '',
                refund_price: '',
                lirun_arr: [],
            },
            tipsMsg: '',
            tableData2: {
                data: [],
                path: '',
            },
            tableData3: {
                data: [],
                path: '',
            },
            turnData: {
                execute_code: '',
                project_name: '',
                resource_name: '',
                platform_name: '',
                is_plarfotm_order: '',
                refund_price: '',
            },
            rules: {
                addPayForm: {
                    execute_ids: [{ required: true, message: '请选择执行', trigger: ['change'] }],
                    new_supplier_id: [
                        { required: true, message: '请选择供应商', trigger: ['change'] },
                    ],
                    invoice_id: [
                        { required: true, message: '请选择开票信息', trigger: ['change'] },
                    ],
                },
                addForm: {
                    plateform_id: [{ required: true, message: '请选择平台', trigger: ['change'] }],
                    supplier_id: [{ required: true, message: '请选择供应商', trigger: ['change'] }],
                    refund_ids: [
                        { required: true, message: '请选择退款记录', trigger: ['change'] },
                    ],
                    execute_ids: [{ required: true, message: '请选择执行', trigger: ['change'] }],
                    payee_bank_id: [
                        { required: true, message: '请选择付款银行', trigger: ['change'] },
                    ],
                    advance_payment_date: [
                        { required: true, message: '请选择付款时间', trigger: ['change'] },
                    ],
                },
                linkForm: {
                    order_num: [{ required: true, message: '请填写订单编号', trigger: ['blur'] }],
                    release_time: [
                        { required: true, message: '请填写发布日期', trigger: ['blur'] },
                    ],
                },
                uploadForm: {
                    excel_file: [
                        {
                            required: true,
                            validator: (rule, value, callback) => {
                                if (
                                    this.uploadForm.excel_file_files.length < 1 &&
                                    this.uploadForm.excel_file_list.length < 1
                                ) {
                                    callback(new Error('请上传文件'))
                                } else {
                                    callback()
                                }
                            },
                            trigger: ['change', 'blur'],
                        },
                    ],
                },
                uploadReplaceForm: {
                    excel_file: [
                        {
                            required: true,
                            validator: (rule, value, callback) => {
                                if (
                                    this.uploadReplaceForm.excel_file_files.length < 1 &&
                                    this.uploadReplaceForm.excel_file_list.length < 1
                                ) {
                                    callback(new Error('请上传文件'))
                                } else {
                                    callback()
                                }
                            },
                            trigger: ['change', 'blur'],
                        },
                    ],
                },
                turnForm: {
                    execute_id: [{ required: true, message: '请选择执行', trigger: ['change'] }],
                    type: [{ required: true, message: '请选择退款类型', trigger: ['change'] }],
                    is_cancel_execute: [
                        { required: true, message: '请选择是否取消执行', trigger: ['change'] },
                    ],
                    refund_bank_id: [
                        { required: true, message: '请选择退款方银行账号', trigger: ['change'] },
                    ],
                    collect_bank_id: [
                        { required: true, message: '请选择退款方银行账号', trigger: ['change'] },
                    ],
                    prove_attachment: [
                        {
                            required: true,
                            validator: (rule, value, callback) => {
                                if (this.turnForm.prove_attachment.length < 1) {
                                    callback(new Error('请上传退款凭证'))
                                } else {
                                    callback()
                                }
                            },
                            trigger: ['change', 'blur'],
                        },
                    ],
                    refund_price: [
                        {
                            required: true,
                            validator: (rule, value, callback) => {
                                if (!value) {
                                    callback(new Error('请填写退款金额'))
                                } else if (value && value > this.turnData.use_refund_price) {
                                    callback(new Error('退款金额不可大于可退款金额！'))
                                } else {
                                    callback()
                                }
                            },
                            trigger: ['change', 'blur'],
                        },
                    ],
                    refund_date: [
                        { required: true, message: '请选择退款日期', trigger: ['change'] },
                    ],
                    refund_reason: [
                        { required: true, message: '请填写退款原因', trigger: ['blur'] },
                    ],
                },
            },
            isDownloading: false,
            isDownDuiZhangloading: false,
            size: 'mini',
            searchForm: {
                platform_id: '',
                project_name: '',
                project_code: '',
                supplier_name: '',
                supplier_code: '',
                execute_code: '',
                resource_name: '',
                status: '',
                is_platform_order: '',
                is_point: '',
                is_payment: '',
                release_time: [],
                create_time: '',
                edit_medium_id: '',
                business_docking_id: '',
                uid: '',
                dept_id: '',
            },
            resetSearch: {
                platform_id: '',
                project_name: '',
                project_code: '',
                supplier_name: '',
                supplier_code: '',
                execute_code: '',
                resource_name: '',
                status: '',
                is_platform_order: '',
                is_point: '',
                is_payment: '',
                release_time: [],
                create_time: '',
                edit_medium_id: '',
                business_docking_id: '',
                uid: '',
                dept_id: '',
            },
            options: {
                is_payment_options: [
                    {
                        value: 1,
                        label: '是',
                    },
                    {
                        value: 2,
                        label: '否',
                    },
                ],
                searchoptions: [
                    {
                        value: 'execute_code',
                        label: '执行编码',
                        disabled: true,
                        selected: true,
                    },
                    {
                        value: 'resource_name',
                        label: '资源名称',
                        disabled: true,
                        selected: true,
                    },
                    {
                        value: 'status',
                        label: '执行状态',
                        disabled: true,
                        selected: true,
                    },
                    {
                        value: 'project_name',
                        label: '项目名称',
                        disabled: true,
                        selected: true,
                    },
                    {
                        value: 'project_code',
                        label: '项目编码',
                        disabled: true,
                        selected: true,
                    },
                    {
                        value: 'supplier_name',
                        label: '供应商名称',
                    },
                    {
                        value: 'supplier_code',
                        label: '供应商编码',
                    },
                    {
                        value: 'platform_id',
                        label: '所属平台',
                    },
                    {
                        value: 'is_platform_order',
                        label: '是否平台下单',
                    },
                    {
                        value: 'is_point',
                        label: '是否返点',
                    },
                    {
                        value: 'is_payment',
                        label: '是否统一结算',
                    },
                    {
                        value: 'release_time',
                        label: '发布日期',
                    },
                    {
                        value: 'business_docking_id',
                        label: '商务',
                    },
                    {
                        value: 'edit_medium_id',
                        label: '媒介执行',
                    },
                    {
                        value: 'uid',
                        label: '客户执行',
                    },
                    {
                        value: 'dept_id',
                        label: '项目所属部门',
                    },
                    {
                        value: 'create_time',
                        label: '创建日期',
                        disabled: true,
                        selected: true,
                    },
                ],
                invoice_id_options: [],
                edit_medium_id_options: [],
                business_docking_id_options: [],
                uid_options: [],
                dept_id_options: [],
                new_supplier_id_options: [],
                refund_options: [],
                invioce_lr_id_options: [],
                bankCard_options: [],
                plateForm_options: [],
                status_options: [
                    {
                        value: '1',
                        label: '待提交',
                    },
                    {
                        value: '2',
                        label: '待审核',
                    },
                    {
                        value: '3',
                        label: '被驳回',
                    },
                    {
                        value: '4',
                        label: '正常',
                    },
                    {
                        value: '5',
                        label: '匹配中',
                    },
                    {
                        value: '6',
                        label: '已发布',
                    },
                    {
                        value: '7',
                        label: '供应商对账',
                    },
                    {
                        value: '8',
                        label: '已作废',
                    },
                    {
                        value: '9',
                        label: '撤销中',
                    },
                    {
                        value: '10',
                        label: '待报价',
                    },
                ],
                is_point_options: [
                    {
                        value: 'YES',
                        label: '是',
                    },
                    {
                        value: 'NO',
                        label: '否',
                    },
                ],
                is_platform_order_options: [
                    {
                        value: 'YES',
                        label: '是',
                    },
                    {
                        value: 'NO',
                        label: '否',
                    },
                ],
                refund_bank_id_options: [],
                collect_bank_id_options: [],
            },
            tableData: {
                total: 0,
                pagesize: 15,
                page: 1,
                data: [],
            },
            selects: [],
            billData: [],
            billNum: '',
            isIndeterminate: true,
            checkAll: false,
        }
    },
    computed: {
        tableHeight: function () {
            return window.innerHeight - 320
        },
        apiMainHeight: function () {
            var height = window.innerHeight - 180
            return { height: height + 'px', border: '1px solid #DCDFE6', 'margin-bottom': '10px' }
        },
        // 计算三个月前的日期
        startDate: function () {
            const date = new Date()
            date.setMonth(date.getMonth() - 3)
            return this.formatDate(date)
        },
        endDate: function () {
            return this.formatDate(new Date())
        },
    },
    mounted: function () {
        this.searchForm.create_time = [this.startDate, this.endDate]
        this.handleSearch(this.searchForm)
        this.getPlateform()
        this.getUserSelect('', '')
        this.getDepartmentOption()
    },
    methods: {
        getBankNumSelect(val){
            if (val == 1) {
                this.getBankNum()
            }
        },
        getBankNum (query) {
			query = query ? query : ''
			this.$api.get('/admin/customers/customer/getbanklineselect', { type: "0,3", nature: "0,5", 'query': query }).then(res => {
				if (res.code === 0) {
                    this.$set(this.options,'bank_num_id_options',res.data)
				}
			})
		},
        handleCheckAllChange (val) {
            this.options.searchoptions.forEach(item => {
                if (!item.disabled) {
                    this.$set(item, 'selected', val)
                }
            });
            this.handleCheckChange()
            this.isIndeterminate = false;
        },
        // 处理选中状态变化
        handleCheckChange (item) {
            this.checked_status = this.options.searchoptions
                .filter(option => option.selected)
                .map(option => option.value)

            const selectedCount = this.options.searchoptions.filter(item => item.selected).length;
            const totalCount = this.options.searchoptions.length
            this.checkAll = selectedCount === totalCount && totalCount !== 0;
            this.isIndeterminate = selectedCount > 0 && selectedCount < totalCount;
        },
        updateStatus (values) {
            if (values.length > 0) {
                // 退款抵扣总和
                let totalCost = this.options.refund_options
                    .filter(record => values.indexOf(record.value) != -1)
                    .reduce((sum, record) => sum + Number(record.balance), 0)
                // 付款金额
                let ccost = this.addForm.resource_project_list.reduce(
                    (sum, record) => sum + Number(record.cost),
                    0
                )

                if (totalCost >= ccost) {
                    this.options.refund_options.forEach((item, index) => {
                        if (values.indexOf(item.value) != -1) {
                            this.$set(this.options.refund_options[index], 'disabled', false)
                        } else {
                            this.$set(this.options.refund_options[index], 'disabled', true)
                        }
                    })
                } else {
                    this.options.refund_options.forEach((item, index) => {
                        this.$set(this.options.refund_options[index], 'disabled', false)
                    })
                }
            } else {
                this.options.refund_options.forEach((item, index) => {
                    this.$set(this.options.refund_options[index], 'disabled', false)
                })
            }
        },
        downloadTemplate: function (type) {
            var file_name = '批量上传发布链接.xlsx'
            this.$api
                .get('/admin/customers/export/exporttemplate', { file_name: file_name })
                .then(res => {
                    if (res.status == 207) {
                        let reader = new FileReader() // 创建读取文件对象
                        reader.readAsText(res.data, 'utf-8') // 设置读取的数据以及返回的数据类型为utf-8
                        reader.addEventListener(
                            'loadend',
                            function () {
                                //
                                let res = JSON.parse(reader.result) // 返回的数据
                                this.$message.error(res.msg)
                            }.bind(this)
                        )
                    } else {
                        // 将Blob转换为URL以便创建一个可下载的链接
                        const url = window.URL.createObjectURL(new Blob([res]))
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', file_name) // 设置下载文件名
                        document.body.appendChild(link)
                        link.click() // 触发点击下载
                        document.body.removeChild(link) // 下载后移除元素
                        window.URL.revokeObjectURL(url) // 释放URL对象
                    }
                })
        },
        //上传发布链接
        addUploadReplace () {
            if (this.$refs.upload_replace_excel_file) {
                this.uploadReplaceForm.excel_file_files = []
                this.$refs.upload_replace_excel_file.submit()
            }
            const formData = new FormData()
            //订单文件
            if (this.uploadReplaceForm.excel_file_files.length > 0) {
                this.uploadReplaceForm.excel_file_files.forEach(item => {
                    formData.append('excel_file', item)
                })
            }
            this.$refs['uploadReplaceForm'].validate(
                function (valid) {
                    if (valid) {
                        this.loading = true
                        this.$api
                            .post('/admin/customers/export/importreplaceexcel', formData)
                            .then(res => {
                                if (res.code === 0) {
                                    // 重新加载表格
                                    this.uploadReplaceVisiable = false
                                    this.tipsMsg = res.msg
                                    this.tableData2.data = res.data
                                    this.tableData2.path = res.other.excel_name
                                    this.tipsVisible = true
                                } else {
                                    this.$message.error(res.msg)
                                }
                                this.loading = false
                            })
                    }
                }.bind(this)
            )
        },
        limitMessageReplace: function (files, fileList) {
            this.$message({
                showClose: true,
                message: `本次选择了 ${files.length} 个文件,超出最大要求数量限制`,
                type: 'warning',
            })
        },
        imggreySuccessReplace: function (files, field) {
            this.uploadReplaceForm[field].push(files.file)
        },
        handleRemoveUploadReplace (file, formobj) {
            this.uploadReplaceForm[formobj] = []
        },
        openUploadReplace () {
            this.uploadReplaceForm.excel_file_files = []
            this.uploadReplaceForm.excel_file_list = []
            this.uploadReplaceVisiable = true
        },
        clearAddForm (form) {
            if (form == 'addForm') {
                this.addForm = {
                    plateform_id: '',
                    pay_status: '',
                    supplier_id: '',
                    is_deduction: 0,
                    supplier_name: '',
                    receive_type: 'OLD',
                    new_supplier_id: '',
                    execute_ids: [],
                    refund_ids: [],
                    resource_project_list: [],
                    payee_bank_id: '',
                    advance_payment_date: '',
                    remark: '',
                    attachment: [],
                }
            } else if (form == 'addPayForm') {
                this.addPayForm = {
                    execute_ids: [],
                    receive_type: 'OLD',
                    supplier_id: '',
                    new_supplier_id: '',
                    invoice_id: '',
                    invoice_array: [],
                    remark: '',
                }
            } else if (form == 'turnForm') {
                this.turnForm = {
                    execute_id: '',
                    refund_method:2,
                    bank_num_id:'',
                    type: '',
                    is_cancel_execute: 2,
                    plarfotm_order: '',
                    refund_bank_id: '',
                    collect_bank_id: '',
                    prove_attachment: [],
                    refund_date: '',
                    refund_price: '',
                    refund_reason: '',
                    remark: '',
                }
            }
            // this.selects = []
            this.$refs.table.clearSelection()
        },
        //获取部门下拉
        getDepartmentOption () {
            this.$api.get('/admin/users/user/getDepartmentTree').then(res => {
                if (res.code === 0) {
                    this.options.dept_id_options = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        getUserSelect (query, type) {
            query = query ? query : ''
            this.$api.post('/admin/users/user/getuserbydepartment', { query: query }).then(res => {
                if (res.code === 0) {
                    if (type == 'meijie') {
                        this.options.edit_medium_id_options = res.data
                    } else if (type == 'kehu') {
                        this.options.uid_options = res.data
                    } else if (type == 'shangwu') {
                        this.options.business_docking_id_options = res.data
                    } else {
                        this.options.edit_medium_id_options = res.data
                        this.options.business_docking_id_options = res.data
                        this.options.uid_options = res.data
                    }
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        tableRowClassName ({ row }) {
            if (row.li_run_lv.includes('-') || row.li_run.includes('-')) {
                return 'negative-row'
            }
            return ''
        },
        remarkaction (row) {
            this.$prompt('请输入备注', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: row.remark == '--' ? '' : row.remark,
                inputValidator: value => {
                    if (!value) {
                        return '备注是必填项'
                    }
                    if (value.length > 255) {
                        return '备注不能超过255个字符'
                    }
                },
                inputErrorMessage: '备注不正确',
            })
                .then(({ value }) => {
                    this.$api
                        .post('/admin/customers/customer/remarkaction', {
                            id: row.id,
                            remark: value,
                        })
                        .then(res => {
                            if (res.code != 0) {
                                this.$message.error(res.msg)
                                return
                            } else {
                                this.$message.success('修改成功')
                                this.tableData.data.forEach((item, index) => {
                                    if (item.id == row.id) {
                                        this.$set(this.tableData.data[index], 'remark', value)
                                    }
                                })
                            }
                        })
                })
                .catch(() => { })
        },
        getPlateform () {
            this.$api.get('/admin/resources/resources/platformdwn').then(res => {
                if (res.code === 0) {
                    this.options.plateForm_options = res.data
                }
            })
        },
        formatDate (date) {
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            return `${year}-${month}-${day}`
        },
        filterStatus (value, row) {
            return row.status == value
        },
        filterPaystatus (value, row) {
            return row.paystatus == value
        },
        filterPointstatus (value, row) {
            return row.point_status == value
        },
        filterinvoicestatus (value, row) {
            return row.invoicestatus == value
        },
        filterinvoicePointstatus (value, row) {
            return row.pointkpstatus == value
        },
        filterPstatus (value, row) {
            return row.platform_status == value
        },
        handleSizeChange (pages) {
            this.tableData.pagesize = pages
            this.handleSearch(this.searchForm, 1)
        },
        getNewSupplier (value) {
            this.addForm.new_supplier_id = ''
            this.addForm.payee_bank_id = ''
            this.addForm.is_deduction = 0
            if (value == 'NEW') {
                this.getSupplierSelect()
            } else {
                this.getBankCard()
            }
        },
        getBankCardNew (val) {
            this.addForm.payee_bank_id = ''
            this.$api
                .get('/admin/resources/resources/supbankdw', { relevance: 1, sid: val })
                .then(res => {
                    if (res.code === 0) {
                        this.options.bankCard_options = res.data
                    } else {
                        this.$message.error(res.msg)
                    }
                })
        },
        getSupplierSelect (query) {
            query = query ? query : ''
            // platform_id:this.addForm.plateform_id,
            this.$api.get('/admin/resources/resources/supldwn', { query: query }).then(res => {
                if (res.code === 0) {
                    this.options.new_supplier_id_options = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        changeRefund (val) {
            if (val == 1) {
                this.addForm.refund_ids = []
                var request_data = {}
				if(this.addForm.pay_status==3){
					request_data = {
						'pay_status':2,
						'plarfotm_id':this.addForm.plateform_id,
                        'bank_id':this.addForm.payee_bank_id
					}
				}else{
					request_data = {
						'pay_status':this.addForm.pay_status,
						'plarfotm_id':this.addForm.receive_type=='OLD' ? this.addForm.supplier_id : this.addForm.new_supplier_id,
						'bank_id':this.addForm.payee_bank_id
					}
                }
                this.$api
                    .get('/admin/resources/resources/refundpricedwlist', request_data)
                    .then(res => {
                        if (res.code === 0) {
                            this.options.refund_options = res.data
                        } else {
                            this.$message.error(res.msg)
                        }
                    })
            }
        },
        exportErrorData (file_name, type) {
            this.$api
                .get('/admin/customers/export/exporterrorexcel', { file_name: file_name })
                .then(res => {
                    // 将Blob转换为URL以便创建一个可下载的链接
                    const url = window.URL.createObjectURL(new Blob([res]))
                    const link = document.createElement('a')
                    link.href = url
                    const parts = file_name.split('-')
                    link.setAttribute('download', this.tableData2.path) // 设置下载文件名
                    // if(type == 1){
                    // 	link.setAttribute('download', '供应商对账失败信息表.xlsx'); // 设置下载文件名
                    // }else if(type == 2){
                    // 	link.setAttribute('download', '确认对账失败信息表.xlsx'); // 设置下载文件名
                    // }else{
                    // 	link.setAttribute('download', '确认对账失败信息表.xlsx'); // 设置下载文件名
                    // }
                    document.body.appendChild(link)
                    link.click() // 触发点击下载
                    document.body.removeChild(link) // 下载后移除元素
                    window.URL.revokeObjectURL(url) // 释放URL对象
                    this.tipsVisible = false
                })
        },
        // 下载对账数据
        exportDuiZhangData () {
            var excelSearch = JSON.parse(JSON.stringify(this.searchForm))
            excelSearch['ids'] = []
            this.selects.forEach(item => {
                excelSearch['ids'].push(item['id'])
            })
            this.isDownDuiZhangloading = true
            excelSearch.downloadType = 'executeDuizhang'
            this.$api
                .get('/admin/customers/export/exportExecuteduizhangexcel', excelSearch)
                .then(res => {
                    // if (res.code == 0) {
                    // 		this.$alert('异步下载任务【执行对账列表下载】创建成功！请稍后查看下载列表', '下载提示', {
                    // 			confirmButtonText: '确定',
                    // 		});
                    // }else{
                    // 	this.$message({
                    // 		type: 'error',
                    // 		message: res.msg
                    // 	});
                    // }
                    // this.isDownDuiZhangloading = false;
                    // 将Blob转换为URL以便创建一个可下载的链接
                    const url = window.URL.createObjectURL(new Blob([res]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', '执行对账明细表.xlsx') // 设置下载文件名
                    document.body.appendChild(link)
                    link.click() // 触发点击下载
                    document.body.removeChild(link) // 下载后移除元素
                    window.URL.revokeObjectURL(url) // 释放URL对象
                    this.isDownDuiZhangloading = false
                    this.$alert('您所下载的Excel数据已完毕,请查收！', '下载提示', {
                        confirmButtonText: '确定',
                    })
                })
        },
        // 下载excel数据
        exportData () {
            this.isDownloading = true // 禁用按钮
            var excelSearch = JSON.parse(JSON.stringify(this.searchForm))
            excelSearch['ids'] = []
            this.selects.forEach(item => {
                excelSearch['ids'].push(item['id'])
            })

            excelSearch.downloadType = 'execute'
            this.$api.get('/admin/customers/export/exportexecuteexcel', excelSearch).then(res => {
                if (res.code == 0) {
                    this.$alert('异步下载任务【执行列表下载】创建成功！请稍后查看下载列表', '下载提示', {
                        confirmButtonText: '确定',
                    });
                } else {
                    this.$message({
                        type: 'error',
                        message: res.msg
                    });
                }
                this.isDownloading = false;
                // // 将Blob转换为URL以便创建一个可下载的链接
                // const url = window.URL.createObjectURL(new Blob([res]))
                // const link = document.createElement('a')
                // link.href = url
                // link.setAttribute('download', '执行明细表.xlsx') // 设置下载文件名
                // document.body.appendChild(link)
                // link.click() // 触发点击下载
                // document.body.removeChild(link) // 下载后移除元素
                // window.URL.revokeObjectURL(url) // 释放URL对象
                // this.isDownloading = false
                // this.$alert('您所下载的Excel数据已完毕,请查收！', '下载提示', {
                //     confirmButtonText: '确定',
                // })
            })
        },
        // 取消对账
        cancelBill (item) {
            var error = []
            var p_error = []
            var suError = []
            var ids = []
            var sup_ids = []
            this.selects.forEach((item, index) => {
                if (sup_ids.indexOf(item['supplier_id']) == -1) {
                    sup_ids.push(item['supplier_id'])
                }
                if (item['status'] != 7) {
                    error.push(1)
                }
                if (item['platform_status'] != 1) {
                    p_error.push(1)
                }
                if (suError.indexOf(item['supplier_id']) == -1) {
                    suError.push(item['supplier_id'])
                }
                ids.push(item['id'])
            })
            if (sup_ids.length > 1) {
                this.$message.error('选中的记录必须是同一供应商，请重新选择')
                this.$refs.table.clearSelection()
                return
            }
            if (error.length > 0) {
                this.$message.error('所选的执行状态应为【供应商对账】,才可以撤销对账')
                this.$refs.table.clearSelection()
                return
            }
            if (suError.length > 1) {
                this.$message.error('所选执行必须为同一供应商')
                this.$refs.table.clearSelection()
                return
            }
            this.$prompt('请输入撤销对账的备注', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValidator: value => {
                    if (!value) {
                        return '请输入【撤销对账】备注,必填项'
                    } else {
                        if (value.length > 30) {
                            return '备注不能超过30个字符'
                        } else {
                            return true
                        }
                    }
                },
                inputErrorMessage: '',
            })
                .then(({ value }) => {
                    this.loading = true
                    this.$api
                        .post('/admin/customers/customer/cancelreconciliation', {
                            execute_ids: ids,
                            remarks: value,
                        })
                        .then(res => {
                            if (res.code === 0) {
                                // 重新加载表格
                                this.handleSearch(this.searchForm)
                                this.$message({
                                    showClose: true,
                                    message: '撤销对账成功',
                                    type: 'success',
                                })
                                this.handleSearch(this.searchForm)
                            } else {
                                this.$message.error(res.msg)
                            }
                            this.loading = false
                        })
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消撤销对账',
                    })
                })
        },
        isColor (text) {
            if (text.includes('上升')) {
                return '#67C23A'
            } else if (text.includes('下降')) {
                return '#F56C6C'
            } else {
                return '#606266'
            }
        },
        isUp (val) {
            if (val.includes('上升')) {
                return val.replace('上升', '↑')
            } else if (val.includes('下降')) {
                return val.replace('下降', '↓')
            } else {
                return val
            }
        },
        //根据发票录入获取对应
        getCost (index) {
            // this.addPayForm.invoice_array[index].cost = 0
            this.$nextTick(() => {
                this.$refs['addPayForm'].clearValidate(`invoice_array[${index}].cost`)
            })
        },
        addInvoicePay () {
            this.$refs['addPayForm'].validate(
                function (valid) {
                    if (valid) {
                        this.loading = true
                        this.$api
                            .post('/admin/customers/customer/applyinvoice', this.addPayForm)
                            .then(res => {
                                if (res.code === 0) {
                                    // 重新加载表格
                                    this.handleSearch(this.searchForm)
                                    this.$message({
                                        showClose: true,
                                        message:
                                            '申请收票成功！前往【财务】->【申请收票】下查看详情',
                                        type: 'success',
                                    })
                                    this.payInvoiceFormVisible = false
                                } else {
                                    this.$message.error(res.msg)
                                }
                                this.loading = false
                            })
                    } else {
                        this.$message({
                            showClose: true,
                            message: '请填写正确的信息！',
                            type: 'warning',
                        })
                    }
                }.bind(this)
            )
        },
        handlePaymentButtonClick () {
            this.payFormVisible = false
            this.initAddForm()
        },
        initAddForm () {
            this.addForm = {
                plateform_id: '',
                pay_status: '',
                supplier_id: '',
                is_deduction: 0,
                supplier_name: '',
                execute_ids: [],
                refund_ids: [],
                resource_project_list: [],
                payee_bank_id: '',
                advance_payment_date: '',
                remark: '',
                attachment: [],
            }
            this.resource_project_list = []
            this.execute_tips = ''
            this.options.bankCard_options = []
            this.options.refund_options = []
            this.handleSearch('', this.tableData.page)
        },
        addInvoice () {
            this.$refs['addForm'].validate(
                function (valid) {
                    if (valid) {
                        this.loading = true
                        if (this.addForm.receive_type == 'NEW') {
                            this.addForm.supplier_id = this.addForm.new_supplier_id
                        }
                        this.addForm.is_submit = 'YES'
                        const formData = new FormData()
                        for (const key in this.addForm) {
                            if (key == 'attachment') {
                                if (this.addForm[key].length > 0) {
                                    this.addForm[key].forEach(item => {
                                        formData.append(key, item)
                                    })
                                } else {
                                    formData.append(key, '')
                                }
                            } else if (
                                key == 'resource_project_list' ||
                                key == 'execute_ids' ||
                                key == 'refund_ids'
                            ) {
                                formData.append(key, JSON.stringify(this.addForm[key]))
                            } else {
                                formData.append(key, this.addForm[key])
                            }
                        }
                        this.$api
                            .post('/admin/resources/resources/pymentrequest', formData)
                            .then(res => {
                                if (res.code === 0) {
                                    // 重新加载表格
                                    this.handleSearch(this.searchForm)
                                    this.$message({
                                        showClose: true,
                                        message:
                                            '申请付款成功！前往【财务】->【申请付款】下查看详情',
                                        type: 'success',
                                    })
                                    this.payFormVisible = false
                                    this.initAddForm()
                                } else {
                                    this.$message.error(res.msg)
                                }
                                this.loading = false
                            })
                    } else {
                        this.$message({
                            showClose: true,
                            message: '请填写正确的信息！',
                            type: 'warning',
                        })
                    }
                }.bind(this)
            )
        },
        validatorLrId (rule, value, callback) {
            let result = rule.field.match(/\[(.*?)\]/)
            let index = result[1]
            if (!value) {
                callback('请填写使用金额')
            } else {
                if (!isNaN(Number(value)) && value > 0) {
                    //实时验证可用票面金额-------发票录入
                    this.$api
                        .post('/admin/resources/resources/pricecheck', {
                            execute_id: this.addForm.resource_project_list[index].execute_id,
                            cost: this.addForm.resource_project_list[index].cost,
                        })
                        .then(res => {
                            if (res.code === 0) {
                                callback()
                            } else {
                                callback('已超出最大可使用金额')
                            }
                        })
                } else {
                    callback('使用金额必须为数字且必须大于0')
                }
            }
        },
        validatorLrIdInvo (rule, value, callback) {
            let result = rule.field.match(/\[(.*?)\]/)
            let index = result[1]
            if (this.addPayForm.invoice_array[index].invioce_lr_id) {
                if (!value) {
                    callback('请填写使用金额')
                } else {
                    if (!isNaN(Number(value)) && value > 0) {
                        //实时验证可用票面金额-------发票录入
                        this.$api
                            .post('/admin/customers/customer/invoicevalidate', {
                                id: this.addPayForm.invoice_array[index].invioce_lr_id,
                                invoice_array: this.addPayForm.invoice_array,
                            })
                            .then(res => {
                                if (res.code === 0) {
                                    if (res.data.maxCost < 0) {
                                        // callback('已超出最大可使用金额')
                                        callback(res.data.msg)
                                    } else {
                                        //获取当前index的发票录入id相同的对象的索引
                                        let val = this.addPayForm.invoice_array[index].invioce_lr_id
                                        let indices = []
                                        for (
                                            let i = 0;
                                            i < this.addPayForm.invoice_array.length;
                                            i++
                                        ) {
                                            if (
                                                this.addPayForm.invoice_array[i].invioce_lr_id ===
                                                val
                                            ) {
                                                indices.push(i)
                                            }
                                        }
                                        for (let i = 0; i < indices.length; i++) {
                                            let newval = indices[i]
                                            //清楚所有相同索引的报错信息
                                            this.$nextTick(() => {
                                                this.$refs['addPayForm'].clearValidate(
                                                    `invoice_array[${newval}].cost`
                                                )
                                            })
                                        }
                                        callback()
                                    }
                                } else {
                                    this.$message.error(res.msg)
                                }
                            })
                    } else {
                        callback('使用金额必须为数字且必须大于0')
                    }
                }
            } else {
                callback('请先选择发票录入')
            }
        },
        handleSelectionChange: function (vals) {
            var arr = []
            var arrpiao = []
            // var supplier_ids = []
            // var platform_ids = []
            var execute_ids = []
            // var names = []
            // var p_names = []
            this.selects = []
            vals.forEach(
                function (item) {
                    this.selects.push(item)
                    execute_ids.push(item['id'])
                    arr.push({
                        execute_id: item['id'],
                        name: item['resource_id_txt'],
                        cost: item['sy_tianxie_yf_price'],
                        invioce_lr_id: '',
                        execute_code: item['execute_code'],
                    })
                    arrpiao.push({
                        execute_id: item['id'],
                        name: item['resource_id_txt'],
                        cost: item['sy_tianxie_ysp_price'],
                        invioce_lr_id: '',
                        execute_code: item['execute_code'],
                    })
                    // if (supplier_ids.indexOf(item['supplier_id']) == -1){
                    // 	supplier_ids.push(item['supplier_id'])
                    // 	names.push(item['supplier_id_txt'])
                    // }
                    // if (platform_ids.indexOf(item['platform_id']) == -1){
                    // 	platform_ids.push(item['platform_id'])
                    // 	p_names.push(item['platform_id_txt'])
                    // }
                }.bind(this)
            )

            this.$set(this.addForm, 'resource_project_list', arr)
            this.$set(this.addForm, 'execute_ids', execute_ids)

            this.$set(this.addPayForm, 'invoice_array', arrpiao)
            this.$set(this.addPayForm, 'execute_ids', execute_ids)
        },
        payOpen: function () {
            var status = []
            var isplateform = []
            var plate = []
            var plate_name = []
            var excu_status = []
            var sup_status = []
            var pro_status = []
            var sup_ids = []
            var sup_names = []
            this.tableData.data.forEach(
                function (item) {
                    if (this.addForm.execute_ids.indexOf(item['id']) != -1) {
                        if (item['paystatus'] == 'all') {
                            status.push(1)
                        }
                        if (isplateform.indexOf(item['is_platform_order']) == -1) {
                            isplateform.push(item['is_platform_order'])
                        }
                        if (plate.indexOf(item['platform_id']) == -1) {
                            plate.push(item['platform_id'])
                            plate_name.push(item['platform_id_txt'])
                        }
                        // 执行状态
                        if ([1, 3, 8, 9, 10].indexOf(item['status']) != -1) {
                            excu_status.push(1)
                        }
                        if ([1, 2, 3, 10].indexOf(item['project_status']) != -1) {
                            pro_status.push(1)
                        }
                        if (item['supplier_status'] != 4) {
                            sup_status.push(1)
                        }
                        if (sup_ids.indexOf(item['supplier_id']) == -1) {
                            sup_ids.push(item['supplier_id'])
                            sup_names.push(item['supplier_id_txt'])
                        }
                    }
                }.bind(this)
            )
            if (sup_status.length > 0) {
                this.$message.error(
                    '选中的记录中存在【供应商待提交/待审核/被驳回】状态，请联系资源部'
                )
                this.$refs.table.clearSelection()
                return
            }
            // if(pro_status.length > 0){
            // 	this.$message.error('选中的记录所属项目存在【待提交/待审核/被驳回/反结案中】状态，请重新选择')
            // 	return
            // }
            if (excu_status.length > 0) {
                this.$message.error(
                    '选中的记录中存在【待提交/被驳回/已作废/撤销中/待报价】状态，请重新选择'
                )
                this.$refs.table.clearSelection()
                return
            }
            if (status.length > 0) {
                this.$message.error('选中的记录中存在【全额付款(含待审核)】状态，请重新选择')
                this.$refs.table.clearSelection()
                return
            }
            if (isplateform.length > 1) {
                this.$message.error('走平台订单和非平台订单不能合并申请付款，请重新选择')
                this.$refs.table.clearSelection()
                return
            }
            if (isplateform[0] == 'YES' && plate.length > 1) {
                this.$message.error('走平台订单所有记录均为同平台才可申请付款，请重新选择')
                this.$refs.table.clearSelection()
                return
            }
            if (isplateform[0] == 'NO' && sup_ids.length > 1) {
                this.$message.error('不走平台订单所有记录均为同供应商才可申请付款，请重新选择')
                this.$refs.table.clearSelection()
                return
            }
            this.payFormVisible = true
            if (isplateform[0] == 'YES') {
                this.addForm.plateform_id = plate[0]
                this.addForm.pay_status = 3
                this.addForm.supplier_name = plate_name[0]
                this.addForm.supplier_id = '0'
            } else {
                this.addForm.pay_status = 1
                this.addForm.supplier_name = sup_names[0]
                this.addForm.supplier_id = sup_ids[0]
            }
            this.addExecuteIds()
            this.getBankCard() //获取发票录入下拉
        },

        addExecuteIds () {
            //获取申请收票界面可收票金额--------执行
            if (this.addForm.execute_ids.length > 0) {
                this.$api
                    .get('/admin/resources/resources/paymentrequestprice', {
                        execute_ids: this.addForm.execute_ids,
                    })
                    .then(res => {
                        if (res.code === 0) {
                            this.execute_tips = res.msg
                        } else {
                            this.$message.error(res.msg)
                        }
                    })
            } else {
                this.execute_tips = ''
            }
        },
        addinvoiceIds () {
            //获取申请收票界面可收票金额--------执行
            if (this.addPayForm.execute_ids.length > 0) {
                this.$api
                    .get('/admin/customers/customer/getapplyinvoicecost', {
                        execute_ids: this.addPayForm.execute_ids,
                    })
                    .then(res => {
                        if (res.code === 0) {
                            this.invoice_tips = res.msg
                        } else {
                            this.$message.error(res.msg)
                        }
                    })
            } else {
                this.invoice_tips = ''
            }
        },
        payInvoiceOpen: function () {
            var status = []
            var project = []
            var sup_ids = []
            var del_status = []
            var plate = []
            var isplateform = []
            this.tableData.data.forEach(
                function (item) {
                    if (this.addPayForm.execute_ids.indexOf(item['id']) != -1) {
                        if (item['invoicestatus'] == 'all') {
                            status.push(1)
                        }
                        if (item['status'] == '8') {
                            del_status.push(1)
                        }
                        if (plate.indexOf(item['platform_id']) == -1) {
                            plate.push(item['platform_id'])
                        }
                        if (isplateform.indexOf(item['is_platform_order']) == -1) {
                            isplateform.push(item['is_platform_order'])
                        }
                        if (sup_ids.indexOf(item['supplier_id']) == -1) {
                            sup_ids.push(item['supplier_id'])
                        }
                        if (project.indexOf(item['project_id']) == -1) {
                            project.push(item['project_id'])
                        }
                    }
                }.bind(this)
            )
            if (isplateform.length > 1) {
                this.$message.error('走平台订单和非平台订单不能合并申请收票，请重新选择')
                this.$refs.table.clearSelection()
                return
            }
            if (isplateform[0] == 'YES' && plate.length > 1) {
                this.$message.error('走平台订单所有记录均为同平台才可申请收票，请重新选择')
                this.$refs.table.clearSelection()
                return
            }
            if (isplateform[0] == 'NO' && sup_ids.length > 1) {
                this.$message.error('非平台订单,选中的记录必须是同一供应商，请重新选择')
                this.$refs.table.clearSelection()
                return
            }
            if (del_status.length > 0) {
                this.$message.error('选中的记录中有【已作废】，请重新选择')
                this.$refs.table.clearSelection()
                return
            }
            if (status.length > 0) {
                this.$message.error('选中的记录中有【全额收票(含待审核)】，请重新选择')
                this.$refs.table.clearSelection()
                return
            }
            // if (project.length > 1) {
            //     this.$message.error('选中的记录必须是同一项目，请重新选择')
            //     this.$refs.table.clearSelection()
            //     return
            // }
            this.payInvoiceFormVisible = true
            this.addinvoiceIds()
            this.getInviocelrId() //获取发票录入下拉
            this.addPayForm.supplier_id = sup_ids[0]
            if (isplateform[0] == 'YES') {
                this.getInvoiceInfoPublic(plate[0], 3)
            } else {
                this.getInvoiceInfoPublic(sup_ids[0], 1)
            }
        },
        getNewInvoiceSupplier (value) {
            this.addPayForm.new_supplier_id = ''
            this.addPayForm.invoice_id = ''
            if (value == 'NEW') {
                this.getSupplierSelect()
            } else {
                var isplateform = []
                var plate = []
                this.tableData.data.forEach(item => {
                    if (this.addPayForm.execute_ids.indexOf(item['id']) != -1) {
                        isplateform.push(item['is_platform_order'])
                        plate.push(item['platform_id'])
                    }
                })
                if (isplateform[0] == 'YES') {
                    this.getInvoiceInfoPublic(plate[0], 3)
                } else {
                    this.getInvoiceInfoPublic(this.addPayForm.supplier_id, 1)
                }
            }
        },
        getInvoiceInfo (value) {
            this.getInvoiceInfoPublic(value, 1)
        },
        getInvoiceInfoPublic (value, relevance) {
            var is_platform_view = relevance == 1 ? 'supplier_id' : 'platform_id'
            this.$api
                .get('/admin/resources/resources/supinvoicedw', {
                    sid: value,
                    relevance: relevance,
                    is_platform_view: is_platform_view,
                })
                .then(res => {
                    if (res.code === 0) {
                        this.options.invoice_id_options = res.data
                    } else {
                        this.$message.error(res.msg)
                    }
                })
        },
        //获取发票录入下拉
        getInviocelrId (query) {
            query = query || ''
            var ids = this.addPayForm.invoice_array.map(item => item.invioce_lr_id)
            this.$api
                .get('/admin/customers/customer/getinvioceentryselect', {
                    query: query,
                    invoice_status: 1,
                    status: true,
                    ids: ids,
                })
                .then(res => {
                    if (res.code === 0) {
                        this.options.invioce_lr_id_options = res.data
                    } else {
                        this.$message.error(res.msg)
                    }
                })
        },
        //获取发票录入下拉
        getBankCard () {
            var id = ''
            if (this.addForm.pay_status == 1) {
                id = this.addForm.supplier_id
            } else if (this.addForm.pay_status == 3) {
                id = this.addForm.plateform_id
            }
            this.$api
                .get('/admin/resources/resources/supbankdw', {
                    sid: id,
                    relevance: this.addForm.pay_status,
                })
                .then(res => {
                    if (res.code === 0) {
                        this.options.bankCard_options = res.data
                    } else {
                        this.$message.error(res.msg)
                    }
                })
        },
        handleSearch: function (params, page, prop, order) {
            this.loading = true
            Object.keys(params).forEach(key => {
                if (
                    this.checked_status.indexOf(key) === -1 &&
                    ['create_time', 'status', 'execute_code', 'resource_name', 'project_name', 'project_code'].indexOf(key) === -1
                ) {
                    delete params[key]
                }
            })
            var param = Object.assign({}, params)
            param['page'] = page ? page : 1
            param['pagesize'] = this.tableData.pagesize
            param['prop'] = prop ? prop : 'id'
            param['order'] = order ? order : 'desc'
            this.$api.get('/admin/customers/customer/getprojectresourcelist', param).then(res => {
                if (res.code === 0) {
                    this.tableData = res.data
                    this.$nextTick(() => {
                        if (this.$refs.table) {
                            this.$refs.table.doLayout()
                        }
                    })
                } else {
                    this.$message.error(res.msg)
                }
                this.loading = false
            })
        },
        // 执行查询
        doSearch () {
            this.handleSearch(this.searchForm)
        },
        // 重置
        reset () {
            this.searchForm = JSON.parse(JSON.stringify(this.resetSearch))
            this.doSearch()
        },
        // 排序
        sortChange (e) {
            var order
            var prop = e.prop
            if (e.order == 'ascending') {
                order = 'asc'
            } else if (e.order == 'descending') {
                order = 'desc'
            } else {
                prop = this.resetSearch.prop
                order = this.resetSearch.order
            }
            this.handleSearch(this.searchForm, 1, prop, order)
        },
        // 改变当前页 page
        handleCurrentChange (val) {
            this.handleSearch(this.searchForm, val)
        },
        // 删除执行明细
        handleTableDelete (row) {
            this.$confirm('此操作将作废该执行明细, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(
                function () {
                    this.loading = true
                    this.$api
                        .delete('/admin/customers/customer/cancelproresource', {
                            execute_code: row.execute_code,
                        })
                        .then(res => {
                            if (res.code === 0) {
                                var data = this.tableData.data
                                data.forEach(
                                    function (item, index) {
                                        if (item.execute_code == row.execute_code) {
                                            this.$set(this.tableData.data[index], 'status', 8)
                                            this.$set(
                                                this.tableData.data[index],
                                                'status_txt',
                                                '已作废'
                                            )
                                        }
                                    }.bind(this)
                                )
                                this.$message({
                                    showClose: true,
                                    message: '该执行明细已成功作废！',
                                    type: 'success',
                                })
                            } else {
                                this.$message.error(res.msg)
                            }
                            this.loading = false
                        })
                }.bind(this)
            )
        },
        //点击查看大图
        viewImg (file) {
            if (!file.path) {
                //还未上传
                let url = URL.createObjectURL(file)
                if (file.name.includes('.pdf')) {
                    window.open(url)
                } else {
                    this.dialogImageUrl = url
                    this.dialogVisibleImg = true
                }
            } else {
                //已上传
                if (file.name.includes('.pdf')) {
                    window.open(file.path)
                } else {
                    this.dialogImageUrl = file.path
                    this.dialogVisibleImg = true
                }
            }
        },
        //上传图片
        changeRequired (file, formobj, field, limitOne = true) {
            if (limitOne) {
                this[formobj][field] = [file.raw]
            } else {
                this[formobj][field].push(file.raw)
            }
        },
        //移除图片
        handleRemoveUpload (file, formobj, field, limitOne = true) {
            if (limitOne) {
                this[formobj][field] = []
            } else {
                this[formobj][field].forEach(
                    function (item, index) {
                        if (item.name == file.name) {
                            this.$delete(this[formobj][field], index)
                        }
                    }.bind(this)
                )
            }
        },
        openLink (item) {
            this.$api
                .get('/admin/customers/customer/getreplaceurl', { execute_id: item.id })
                .then(res => {
                    if (res.code === 0) {
                        this.linkForm = res.data
                        if (item.is_platform_order == 'YES') {
                            this.$set(this.linkForm, 'order_num_show', true)
                        }
                        this.$set(this.linkForm, 'execute_id', item.id)
                        this.$set(this.linkForm, 'release_time', item.release_time)
                        this.linkVisible = true
                    } else {
                        this.$message.error(res.msg)
                    }
                })
        },
        addLink () {
            const formData = new FormData()
            for (const key in this.linkForm) {
                if (key == 'img') {
                    if (this.linkForm[key].length > 0) {
                        this.linkForm[key].forEach(item => {
                            formData.append(key, item)
                        })
                    }
                } else {
                    formData.append(key, this.linkForm[key])
                }
            }
            this.$refs['linkForm'].validate(
                function (valid) {
                    if (valid) {
                        if (!this.linkForm.replace_url && this.linkForm.img.length < 1) {
                            this.$message.error('请填写发布链接或图片!')
                            return
                        }
                        this.loading = true
                        this.$api
                            .post('/admin/customers/customer/completePublished', formData)
                            .then(res => {
                                if (res.code === 0) {
                                    // 重新加载表格
                                    this.handleSearch(this.searchForm)
                                    this.$message({
                                        showClose: true,
                                        message: '发布链接成功！',
                                        type: 'success',
                                    })
                                    this.linkVisible = false
                                } else {
                                    this.$message.error(res.msg)
                                }
                                this.loading = false
                            })
                    } else {
                        this.$message({
                            showClose: true,
                            message: '请填写正确的信息！',
                            type: 'warning',
                        })
                    }
                }.bind(this)
            )
        },
        //打开对账窗口
        openBill () {
            let status = []
            let point_status = []
            let sup_ids = []
            this.billData = []

            this.tableData.data.forEach(
                function (item) {
                    if (this.addPayForm.execute_ids.indexOf(item['id']) != -1) {
                        if (sup_ids.indexOf(item['supplier_id']) == -1) {
                            sup_ids.push(item['supplier_id'])
                        }
                        if (item['status'] != 6) {
                            status.push({
                                code: item['execute_code'],
                                msg: '该执行必须是【已发布】状态才可确认对账',
                            })
                        } else if (
                            item['is_platform_order'] == 'YES' &&
                            item['point_price_cost'] <= 0
                        ) {
                            point_status.push({
                                code: item['execute_code'],
                                msg: '该执行是平台下单，没有返点可以对账',
                            })
                        } else {
                            this.billData.push(item)
                        }
                    }
                }.bind(this)
            )
            if (sup_ids.length > 1) {
                this.$message.error('选中的记录必须是同一供应商，请重新选择')
                this.$refs.table.clearSelection()
                return
            }
            let mergedArray = [...status, ...point_status]
            if (mergedArray.length > 0) {
                this.tableData3.data = mergedArray
                this.tipsVisible2 = true
                //this.$message.error('执行明细必须是已发布状态才可确认对账，请重新选择！')
            } else {
                //确认对账
                this.billNum = this.billData.length
                this.billVisible = true
            }
        },
        //确认对账
        confirmbill () {
            let ids = []
            this.billData.forEach((item, index) => {
                ids.push(item.id)
            })
            this.$api
                .post('/admin/customers/customer/confirmreconciliation', { execute_ids: ids })
                .then(res => {
                    if (res.code === 0) {
                        // 重新加载表格
                        this.handleSearch(this.searchForm)
                        this.$message({
                            showClose: true,
                            message: '已确认对账！',
                            type: 'success',
                        })
                        this.billVisible = false
                    } else {
                        this.tableData3.data = res.data
                        this.tipsVisible2 = true
                        //   this.$message.error(res.msg);
                    }
                    this.$refs.table.clearSelection()
                })
        },
        //上传订单弹窗打开
        openUpload () {
            this.uploadForm.excel_file_files = []
            this.uploadForm.excel_file_list = []
            this.uploadVisiable = true
        },
        //上传订单
        addUpload () {
            if (this.$refs.upload_excel_file) {
                this.uploadForm.excel_file_files = []
                this.$refs.upload_excel_file.submit()
            }
            const formData = new FormData()
            //订单文件
            if (this.uploadForm.excel_file_files.length > 0) {
                this.uploadForm.excel_file_files.forEach(item => {
                    formData.append('excel_file', item)
                })
            }
            this.$refs['uploadForm'].validate(
                function (valid) {
                    if (valid) {
                        this.loading = true
                        this.$api
                            .post('/admin/customers/export/importexecuteexcel', formData)
                            .then(res => {
                                if (res.code === 0) {
                                    // 重新加载表格
                                    this.uploadVisiable = false
                                    this.tipsMsg = res.msg
                                    this.tableData2.data = res.data
                                    this.tableData2.path = res.other.excel_name
                                    this.tipsVisible = true
                                } else {
                                    this.$message.error(res.msg)
                                }
                                this.loading = false
                            })
                    }
                }.bind(this)
            )
        },
        limitMessage: function (files, fileList) {
            this.$message({
                showClose: true,
                message: `本次选择了 ${files.length} 个文件,超出最大要求数量限制`,
                type: 'warning',
            })
        },
        imggreySuccess: function (files, field) {
            this.uploadForm[field].push(files.file)
        },
        handleRemoveUpload2 (file, formobj) {
            this.uploadForm[formobj] = []
        },
        refundOpen () {
            if (this.selects.length > 1) {
                this.$message.error('退款申请不支持多条同时申请，请重新选择！')
                this.$refs.table.clearSelection()
            } else {
                if (this.selects[0].status == 8) {
                    this.$message.error('该条执行已作废，请重新选择！')
                    this.$refs.table.clearSelection()
                    return
                }
                if ([8, 9, 10, 11].indexOf(this.selects[0].project_status) != -1) {
                    this.$message.error(
                        '该条执行所属项目【结案中】/【已结案】/【反结案中】/【媒介变更领取中】，请重新选择！'
                    )
                    this.$refs.table.clearSelection()
                    return
                }
                if (this.selects[0].paystatus == 'other' || this.selects[0].paystatus == 'all') {
                    this.turnForm = {
                        execute_id: '',
                        refund_method:2,
                        bank_num_id:'',
                        type: '',
                        is_cancel_execute: 2,
                        plarfotm_order: '',
                        refund_bank_id: '',
                        collect_bank_id: '',
                        prove_attachment: [],
                        refund_date: '',
                        refund_price: '',
                        refund_reason: '',
                        remark: '',
                    }
                    this.turnData = {
                        execute_code: '',
                        project_name: '',
                        resource_name: '',
                        platform_name: '',
                        is_plarfotm_order: '',
                        refund_price: '',
                        lirun_arr: [],
                    }
                    this.$nextTick(() => {
                        this.$refs['turnForm'].clearValidate()
                    })
                    this.turnFormVisiable = true
                    this.loading = true
                    let turntype
                    if (this.selects[0].is_platform_order == 'YES') {
                        turntype = 2
                    } else if (this.selects[0].is_platform_order == 'NO') {
                        turntype = 1
                    }
                    this.$api
                        .get('/admin/customers/customer/projectinforefundprice', {
                            execute_id: this.selects[0].id,
                            refund_type: turntype,
                        })
                        .then(res => {
                            if (res.code === 0) {
                                this.turnData = res.data
                                this.turnForm.execute_id = this.selects[0].id
                                this.turnForm.type = res.data.refund_type
                                this.turnForm.refund_price = ''
                                if (res.data.refund_type == 1) {
                                    this.getBank()
                                }
                            } else {
                                this.$message.error(res.msg)
                            }
                            this.loading = false
                        })
                } else {
                    this.$message.error('该执行当前未付款，请重新选择！')
                }
            }
        },
        changePrice () {
            this.$api
                .get('/admin/customers/customer/projectinforefundprice', {
                    execute_id: this.turnForm.execute_id,
                    refund_price: this.turnForm.refund_price,
                })
                .then(res => {
                    if (res.code === 0) {
                        this.turnData.lirun = res.data.lirun
                        this.turnData.lirun_arr = res.data.lirun_arr
                    }
                })
        },
        getBank () {
            this.$api
                .get('/admin/customers/customer/refundbankcardlist', {
                    execute_id: this.selects[0].id,
                    refund_type: this.turnForm.type,
                })
                .then(res => {
                    if (res.code === 0) {
                        this.options.refund_bank_id_options = res.data
                    }
                })
            this.$api
                .get('/admin/customers/customer/collectbankcardlist', {
                    execute_id: this.selects[0].id,
                    refund_type: this.turnForm.type,
                })
                .then(res => {
                    if (res.code === 0) {
                        this.options.collect_bank_id_options = res.data
                    }
                })
        },
        addTurn () {
            const formData = new FormData()
            for (const key in this.turnForm) {
                if (key == 'prove_attachment') {
                    if (this.turnForm[key].length > 0) {
                        this.turnForm[key].forEach(item => {
                            formData.append(key, item)
                        })
                    } else {
                        formData.append(key, '')
                    }
                } else {
                    formData.append(key, this.turnForm[key])
                }
            }
            this.$refs['turnForm'].validate(
                function (valid) {
                    if (valid) {
                        this.loading = true
                        this.$api
                            .post('/admin/customers/customer/createsubmitrefundRequest', formData)
                            .then(res => {
                                if (res.code == 0) {
                                    // 重新加载表格
                                    this.handleSearch(this.searchForm)
                                    this.$message({
                                        showClose: true,
                                        message: '退款申请已进入审批流程，等待审核！',
                                        type: 'success',
                                    })
                                    this.turnFormVisiable = false
                                } else {
                                    this.$message.error(res.msg)
                                }
                                this.loading = false
                            })
                    
                    }                        
                }.bind(this)
            )
        },
    },
}
</script>
<style lang="scss" scoped>
.kBill .title {
    border-bottom: none !important;
    color: #409eff;
}

.top {
    line-height: 30px;
    font-size: 14px;
    color: #606266;
    border-bottom: 1px solid #dcdfe6;
    padding-bottom: 15px;
    margin-bottom: 15px;
}

.kBill .box {
    height: calc(60vh - 80px);
    overflow: auto;
}
</style>
